/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name: Annotation.js
 *
 * Description:	Code to encapsulate the Annotation JavaScript object.
 *
 */

(function () {
	"use strict";

	// Single global instance of colours.
	var g_AvailableColours = ["blue", "red", "green", "orange", "purple", "cyan", "yellow", "magenta", "grey"];

	/**
	 * Prototype for holding an individual annotation
	 * @param {type} approvalId - The ID of the Approval that this annotation is to be attached to.
	 */
	function Annotation(approvalId) {
		this.createdDate = null;
		this.modifiedDate = null;
		this.g_iApprovalId = approvalId;
		// The type of the annotation
		this.g_iAnnotationType = eAnnotationTypes.Rectangle;
		this.g_szColour = "";
		this.g_oAnnotationData = null;
		this.g_iOrigx = 0;
		this.g_iOrigy = 0;
		this.g_oDrawArray = [];			// Used to hold the annotation bounding box coordinates.
		this.g_oDrawCoordSetArray = []; // Used to hold the object array for each annotation shape point. Needed to send the annotationCoordId to the server.
		this.g_oMarqueeDrawArray = [];	// Used to hold the original Marquee coordinates as the Tech Tools Text Measurement needs them to reacquire the word list.
		// UV coordinates for translating 3d to 2D annotations
		this.g_iuvX = 0;
		this.g_iuvY = 0;
		this.id = -1;
		// Properties to hold the annotation text content.
		this.g_oTextMeasurementWordsArray = [];
		// Login Id of the users.
		this.g_iAuthor = 0;
		this.g_szAuthorEmail = "";
		this.g_szAuthorDisplayName = "";
		this.modifiedDate = null;
		this.g_oReplies = [];
		this.g_oStatuses = [];
		this.g_bClosed = true;
		this.g_bSaved = false;
		this.g_bReadState = true;
		this.g_bVisible = true;
		this.g_iParentAnnotationId = 0;
		this.g_iNumber = 0;
		this.g_iDocumentId = 0;
		this.g_iDocumentPageId = null;
		this.g_bUnlocked = false;
		this.dirtystate = false;
		this.status = "";
		this.g_bSVGTextAnnotation = false;
		this.g_bSVGHoverAnnotation = false;
		this.g_bSVGSearchAnnotation = false;
		this.g_bSVGPositionUpdated = false;
		this.g_oSVGVariable = null;
		this.g_szSVGOriginalContent = "";
		this.g_szTextHighlightContent = "";
		this.attachments = [];
	}

	/*
	 *  - - - P U B L I C   M E T H O D S - - -
	 */

	/**
	 * Renders an annotation div.
	 * @param {int} type - What type of annotation to render.
	 * @param {bool} editableInputType - Is to be rendered in read only mode.
	 * @param {int} annotationReplyId - The ID of the reply which we are creating.
	 * @param {any} oArtworkCanvas - The artwork canvas.
	 * @param {any} oAnnotationCanvas - The annotation canvas.
	 */
	Annotation.prototype.createAnnotationDiv = function (type, editableInputType, annotationReplyId, oArtworkCanvas, oAnnotationCanvas) {
		var svgDivID;
		var classNames;
		var origSvgDivID;
		var oDestination;
		var sztextContent = this.g_szTextContent;
		var oAnnotationReplies = this.g_oReplies;
		var oAnnotationStatuses = this.g_oStatuses;
		var annotationDate = this.modifiedDate || this.createdDate;
		var szArtworkCanvasId = oArtworkCanvas.g_szCanvasId;
		var annotationIsReadOnly = editableInputType;

		// This will convert the hex string (if needed), to the class colour.
		var szAnnotationcolour = g_oAnnotations.getStringColour(this.g_szColour);
		
		// If this is being drawn on the canvas
		if (type === eAnnotationDivType.Popup) {
			svgDivID = this.id;
			origSvgDivID = this.id;

			classNames = "speechbubble annotation annotation" + szAnnotationcolour;
			this.g_bClosed = false;

			// Close any active bubbles, unless suppressed.
			if (g_oAnnotations.g_bOverrideCloseBubble) {
				g_oAnnotations.g_bOverrideCloseBubble = false;
			}
			else {
				for (var i = 0; i < g_oActiveBubbles.length; i++) {
					g_oGreenlightMessages.closeBubble(g_oActiveBubbles[i].id, true, true);
				}
			}

			// Remove all highlighted buttons.
			$(".techToolType").css("background-color", "");
			removeExistingHighlights(null);

			// Enable handle mouseover checking
			changeCanvasFunction();
		}
		// If this is a list item.
		else {
			svgDivID = "li_" + this.id;
			origSvgDivID = this.id;
			classNames = "annotationListItem annotationlist" + szAnnotationcolour;
		}

		var annotationStack = g_oAnnotations.filteredAnnotationStack(g_oAnnotations.g_oAnnotationsMade);

		// Iterate through the annotations and set the div children to open
		for (var i = 0; i < annotationStack.length; i++) {
			if (annotationStack[i].g_iParentAnnotationId == svgDivID) { // Only when opening a pop-up
				annotationStack[i].g_bClosed = false;
			}
		}

		// Begin to build up the div elements.
		var newDiv = document.createElement("div");
		newDiv.id = svgDivID;
		newDiv.className = classNames;
		newDiv.setAttribute("data-artworkcanvas", szArtworkCanvasId);

		// Set the Destination of the object.
		if (type === eAnnotationDivType.Popup) {
			oDestination = document.getElementById("divViewerCell");
			// Set CSS to display to none to avoid the canvas widths from going out of sync.
			$(newDiv).css("display", "none");
		}
		else {
			oDestination = document.getElementById("divAnnDiv_ListItems");
		}

		// Apply the div.
		$(oDestination).append(newDiv);

		// For 3D Annotations, place it statically.
		if (this.g_iAnnotationType === eAnnotationTypes.ThreeD && type === eAnnotationDivType.Popup) {
			var existingAnnotation = $.grep(oArtworkCanvas.g_oScene.children, function (child) { return child.Id == svgDivID; });
			if (existingAnnotation.length > 0) {
				var oAnnotation2DCoords = this.threeDToTwoDCoords(existingAnnotation[0].position, oArtworkCanvas, oAnnotationCanvas);
				oAnnotation2DCoords.x += oArtworkCanvas.g_oContainer.offsetLeft;
				$(newDiv).css({ "left": oAnnotation2DCoords.x, "top": oAnnotation2DCoords.y });
				$(newDiv).css({ "width": 350 });
				$(newDiv).addClass("noAfter");
				$(newDiv).show();
			}
		}

		// Now we are adding to the bubble itself
		// Reset the destination
		oDestination = document.getElementById(svgDivID);

		// Add header bar.
		var oHeaderBar = addDomElement("hb_" + svgDivID, "div", null, "HeaderBar", null, null, oDestination);
		oHeaderBar.setAttribute("data-artworkcanvas", szArtworkCanvasId);

		// Track if a delete button is going to be added.
		// -- If this is the main canvas, the approval is not read only, the user is the author or unlocked, and the annotation has no replies or statuses.
		// -- If this is the main canvas, the approval is read only, and this is a new text measurement or new SVG text annotation.
		// -- If this is the compare canvas, and this is a new text measurement, text highlight or SVG text annotation.
		var bAddDeleteButton = ((oArtworkCanvas.g_bMainCanvas && !g_oViewer.g_bReadOnly && (this.g_iAuthor === g_oUserDetails.UserId || this.g_bUnlocked) && $.isEmptyObject(this.g_oReplies) && $.isEmptyObject(this.g_oStatuses)) ||
			(oArtworkCanvas.g_bMainCanvas && g_oViewer.g_bReadOnly && (this.g_iAnnotationType === eAnnotationTypes.TextMeasurement || this.g_iAnnotationType === eAnnotationTypes.TextHighlight || this.g_iAnnotationType === eAnnotationTypes.TextClassification || this.g_bSVGTextAnnotation) && this.id < 0) ||
			(!oArtworkCanvas.g_bMainCanvas && (this.g_iAnnotationType === eAnnotationTypes.TextMeasurement || this.g_iAnnotationType === eAnnotationTypes.TextHighlight || this.g_iAnnotationType === eAnnotationTypes.TextClassification || this.g_bSVGTextAnnotation) && this.id < 0));

		// A new annotation has no close option - save or delete only!
		if ((type === eAnnotationDivType.Popup) && (this.id > 0 || !bAddDeleteButton)) {		// If it's not a new annotation or there's no delete button (MUST have a delete button, close button or both).
			// Add close button
			addDomElement(svgDivID + "_clo", "input", "img/Cancel-Close_wht_24.png", "closebutton", g_oAnnotations.c_szCloseAnnotation, null, oHeaderBar);
		}

		// Determine if a delete/copy button should be added.
		if (bAddDeleteButton) {

			// Add the delete button.
			addDomElement(svgDivID + "_del", "input", "img/Delete_wht_24.png", "deletebutton", g_oAnnotations.c_szDeleteAnnotation, null, oHeaderBar);

			// Copy Annotation button.
			if (g_bMultiView && this.id > 0 && this.g_iAnnotationType === eAnnotationTypes.Global) {

				// Also make sure it's not in the blocked copy array.
				if ($.inArray(this.id, g_oMultiView.copiedAnnotationIds) === -1) {
					addDomElement(svgDivID + "_batchAdd", "input", "img/Ann_Copy_All_v2.svg", "copybatchbutton", g_oAnnotations.c_szCopyAnnotationBatch, null, oHeaderBar);
				}
			}
		}

		// Add an annotation audit icon if this is not a new annotation.
		if (this.id > 0) {
			addDomElement(svgDivID + "_annotationaudit", "input", "img/Annotation-Audit_wht_24.png", "annotationauditbutton", g_oAudit.c_szOpenAnnotationAudit, null, oHeaderBar);
		}

		// Add an annotation data icon if this annotation has data to be shown.
		if (this.g_oAnnotationData != null && this.g_oAnnotationData.AdditionalData != null && this.id > 0) {
			addDomElement(svgDivID + "_annotationdata", "input", "img/Annotation-Data_wht_24.png", "annotationdatabutton", "View Annotation Data", null, oHeaderBar);
		}

		// Add document attachment icon if the user created this annotation, or this is an unlocked annotation.
		if ((this.g_iAuthor === g_oUserDetails.UserId || this.g_bUnlocked) && !g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas) {
			addDomElement(svgDivID + "_annotationattachment", "input", "img/paperclip_wht_24.png", "annotationattachmentbutton", g_oAnnotations.c_szAnnotationAttachDocumentPrompt, null, oHeaderBar);
		}

		// If this is a list item.
		if (type === eAnnotationDivType.ListItem) {

			// List items get a number.
			var annNumberContainer = document.createElement("span");
			annNumberContainer.className = "annNumber";
			annNumberContainer.innerHTML = this.g_iNumber;

			// Hide the list item number if required.
			if (!g_oSettings.g_oUserSettings.ShowAnnotationNumbers) {
				annNumberContainer.style.display = "none";
			}

			// Add the list item number.
			oDestination.appendChild(annNumberContainer);
		}

		// No date means a new annotation! Make it editable by default
		// Or if we called this function via the edit button in which case the editableInputType will be false (for main text box)
		if (annotationDate == null || !editableInputType) {
			annotationIsReadOnly = false;
			annotationDate = Date.now();
			changeCanvasFunction("#AnnotationViewer");
		}

		// If it's an annotation created by the Text Measurement or Text Highlight tool on an Asset, the annotation needs to be read-only if this is not a live approval.
		if ((this.g_iAnnotationType === eAnnotationTypes.TextMeasurement || this.g_iAnnotationType === eAnnotationTypes.TextHighlight || this.g_iAnnotationType === eAnnotationTypes.TextClassification) && (g_oAnnotations.g_iApprovalId === 0 || g_oViewer.g_bReadOnly)) {
			annotationIsReadOnly = true;
		}

		// If this is an SVG annotation, the annotation needs to be read-only if this is not a live approval or the user does not have text edit access.
		if (this.g_bSVGTextAnnotation && (g_oAnnotations.g_iApprovalId === 0 || g_oViewer.g_bReadOnly || !g_oUserDetails.CreateTextEditing)) {
			annotationIsReadOnly = true;
		}

		// If this annotation is not on the main canvas, the annotation needs to be read-only.
		if (!oArtworkCanvas.g_bMainCanvas) {
			annotationIsReadOnly = true;
		}

		// Create the popup content div.
		var oPopupContent = document.createElement("div");
		$(oPopupContent).addClass("popup-content");
		oDestination.appendChild(oPopupContent);

		// Outline the default JQTE options to be used.
		var oJQTEOptions = null;

		// Outline the default JQTE background colour to be used.
		var szJQTEBackgroundColour = null;

		// If this is an editable SVG text annotation.
		if (this.g_bSVGTextAnnotation === true && !annotationIsReadOnly) {

			// Get the JQTE options for this SVG text annotation.
			oJQTEOptions = g_oSVGText.getJQTEOptions(this.g_oSVGVariable.switchId, oArtworkCanvas, oAnnotationCanvas);

			// Get the JQTE background colour for this SVG text annotation.
			szJQTEBackgroundColour = g_oSVGText.getJQTEBackgroundColour(this.g_oSVGVariable.switchId, oArtworkCanvas, oAnnotationCanvas);
		}

		// If this is an editable text classification annotation.
		if (this.g_iAnnotationType === eAnnotationTypes.TextClassification && !annotationIsReadOnly) {

			// Get the JQTE options for text classification annotations.
			oJQTEOptions = g_oAnnotationTextClassification.g_oJQTEOptions;
		}

		// Create the annotation text area.
		this.createAnnotationTextArea("ti" + svgDivID, this.g_iAuthor, this.g_szAuthorEmail, this.g_szAuthorDisplayName, 0, annotationIsReadOnly, sztextContent, oPopupContent, annotationDate, this.id, oArtworkCanvas, oAnnotationCanvas, oJQTEOptions, szJQTEBackgroundColour);

		// Create an annotation text area for any replies that exist.
		if (oAnnotationReplies !== null) {
			var replyContainer = document.createElement("div");
			var replyContainerId = "rc_" + svgDivID;
			replyContainer.id = replyContainerId;
			oPopupContent.appendChild(replyContainer);

			// Assume this is a reply.
			var iFieldType = eFieldTypes.ReplyHeader;

			var bReadOnly = true;
			for (var j = 0; j < oAnnotationReplies.length; j++) {
				// If this is the same author, we are loading in edit mode, only render the reply in edit mode that was clicked.
				if (parseInt(oAnnotationReplies[j].g_iAuthor) === g_oUserDetails.UserId && editableInputType
					&& oAnnotationReplies[j].id == annotationReplyId && this.g_iApprovalId === g_oAnnotations.g_iApprovalId) {
					bReadOnly = false;
				}

				// Determine the date to be used.
				var oReplyDate = oAnnotationReplies[j].modifiedDate || oAnnotationReplies[j].createdDate;
				
				oAnnotationReplies[j].createAnnotationTextArea("ar_" + (type === eAnnotationDivType.Popup ? "" : "li_") + oAnnotationReplies[j].g_iParentAnnotationId, oAnnotationReplies[j].g_iAuthor, oAnnotationReplies[j].g_szAuthorEmail, oAnnotationReplies[j].g_szAuthorDisplayName, iFieldType, bReadOnly, oAnnotationReplies[j].g_szTextContent, document.getElementById(replyContainerId), oReplyDate, oAnnotationReplies[j].id, oArtworkCanvas, oAnnotationCanvas, null, null);
				iFieldType = eFieldTypes.ReplyHeader;
				bReadOnly = true;
			}
		}

		// Create the status container div.
		var statusContainer = document.createElement("div");
		var statusContainerId = "sc_" + svgDivID;
		statusContainer.id = statusContainerId;
		oDestination.appendChild(statusContainer);

		// Add in any annotation statuses.
		if (oAnnotationStatuses !== null) {
			iFieldType = eFieldTypes.StatusHeader;
			bReadOnly = true;
			for (var j = 0; j < oAnnotationStatuses.length; j++) {
				var annStatusList = ["Initial", "Approved", "Rejected", "Query", "ToDo"];
				this.createAnnotationTextArea(oAnnotationStatuses[j].id, oAnnotationStatuses[j].g_iAuthor, oAnnotationStatuses[j].g_szAuthorEmail, oAnnotationStatuses[j].g_szAuthorDisplayName, iFieldType, bReadOnly, annStatusList[oAnnotationStatuses[j].g_iAnnotationStatus], document.getElementById(statusContainerId), new Date(oAnnotationStatuses[j].annotationStatusDateTime), undefined, oArtworkCanvas, oAnnotationCanvas, null, null);
			}
		}

		// Add in the status buttons.
		if (this.createdDate !== null && g_oUserDetails.CreateStatus && !g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas) {

			// The status icons require two classes to enable the event which is called when setting a status
			// to set the CSS correctly. The group as a whole (all four statuses) has a class set per annotation div, to allow
			// for the resetting of the class from the same event. We also require a class each status separately. This cannot
			// be an Id, as it will exist as both a list item and on the canvas.
			var statusGroupId = "statusGroup_" + this.id;

			// Get any existing status left by this user.
			var oExistingStatus = $.grep(this.g_oStatuses, function (status) { return status.g_iAuthor == g_oUserDetails.UserId; });

			// If this is an unlocked annotation, all users share a single annotation status.
			if (this.g_bUnlocked) {
				oExistingStatus = this.g_oStatuses;
			}

			// Extract the existing status to be used.
			var iExistingStatus = oExistingStatus.length === 0 ? 0 : oExistingStatus[0].g_iAnnotationStatus;

			// Render the status icons.
			this.renderAnnotationStatusIcons(statusGroupId, oDestination, iExistingStatus, svgDivID);
		}

		// Add in the annotation reply buttons.
		if ((annotationIsReadOnly || !editableInputType) && this.createdDate !== null && g_oUserDetails.CreateReply && !g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas) {
			var oThisAnnotation = this;

			// Outline the button function.
			var replyButtonFunction = function () {

				// Do not allow for multiple editors, so return early.
				if ($('.jqte_editor').length > 0) {
					g_oGreenlightMessages.displayWarningBubble(g_oAnnotations.c_szUnsavedAnnotationReply);
					g_oAnnotations.g_bOverrideCloseBubble = true;
					return;
				}

				// Determine if this is a list item.
				var szButtonId = (event.toElement == undefined) ? event.target.id : event.toElement.id;
				var bListItem = szButtonId.indexOf("_li_") != -1;

				// Get the annotation.
				var oAnnotationItem = bListItem ? $("#li_" + oThisAnnotation.id)[0] : $("#" + oThisAnnotation.id)[0];
				
				// If this is a popup that will overflow the bottom of the canvas.
				if (!bListItem && Annotation.prototype.preReplyScrollRequired(oAnnotationItem)) {

					// Move the popup up to make room for the reply.
					$(oAnnotationItem).css("top", (parseInt($(oAnnotationItem).css("top").replace("px", "")) - 100) + "px");
				}

				// Create the reply text area.
				var id = origSvgDivID;
				var result = $.grep(annotationStack, function (annotation) { return annotation.id == oThisAnnotation.id; });
				result[0].createAnnotationTextArea("ar_" + svgDivID, oThisAnnotation.g_iAuthor, g_oUserDetails.EmailAddress, "", 1, 0, "", document.getElementById(replyContainerId), Date.now(), id, oArtworkCanvas, oAnnotationCanvas, null, null);
				result[0].g_bSaved = false;

				// Auto scroll the annotation.
				Annotation.prototype.scrollReplyAnnotation(oAnnotationItem, bListItem);
			};

			addDomElement("rb_" + svgDivID, "input", "img/Reset-Form_wht_16.png", "replyButton", g_oAnnotations.c_szAnnotationAddReplyPrompt, replyButtonFunction, oDestination);
			$(".addShapeButton").css("cursor", "pointer"); // IE & Edge don't like this set through the CSS, so force it manually.
		}

		// Add multi shape support.
		// Only show button if the user is the original author of the annotation, it isn't a global annotation
		// and it isn't a 3D or SVG Text Annotation.
		if (this.g_iAuthor === g_oUserDetails.UserId && this.createdDate !== null && !g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas
			&& (this.g_iAnnotationType !== eAnnotationTypes.Global && this.g_iAnnotationType !== eAnnotationTypes.ThreeD && this.g_iAnnotationType !== eAnnotationTypes.TextMeasurement && this.g_iAnnotationType !== eAnnotationTypes.TextHighlight && this.g_iAnnotationType !== eAnnotationTypes.TextClassification && this.g_iAnnotationType !== eAnnotationTypes.BarcodeMeasurement
				&& this.g_iAnnotationType !== eAnnotationTypes.ColourDensityMeasurement && this.g_iAnnotationType !== eAnnotationTypes.ColourDensityMeasurementPostit && this.g_bSVGTextAnnotation !== true)) {
			var oCurrentAnnotation = this;
			g_oAnnotations.g_oLastAnnotation = this;
			var addShapeButtonFunction = function () {

				// Display the add shape info bubble.
				g_oGreenlightMessages.displayInfoBubble(g_oAnnotations.c_szMakingShapeTip, true);
				$('#AnnotationViewer').css("cursor", "crosshair");
				g_oAnnotations.g_szPrevCursorStyle = "crosshair";

				// Get the artwork and annotation canvas.
				var oArtworkCanvas = g_oViewer.getCanvas(szArtworkCanvasId);
				var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;

				// Delete the div to clear the dotted line to annotation div if present
				$(this).parent().remove();
				g_oAnnotations.rebuildAnnotationList(oArtworkCanvas, oAnnotationCanvas);

				$(".annotationviewer").off("pointerdown");
				$(".annotationviewer").off("pointerup");

				oAnnotationCanvas.redraw(false);
				var result = $.grep(annotationStack, function (annotation) { return annotation.id == oCurrentAnnotation.id; });

				// Set the annotation type and colour to the same as the parent
				g_oAnnotations.g_iAnnotationType = result[0].g_iAnnotationType;
				g_oAnnotations.g_oAnnotationColSelected = g_oAnnotations.getStringColour(result[0].g_szColour);

				// Update colour preference by faking a click on the correct colour.
				$("#annotate" + g_oAnnotations.g_oAnnotationColSelected[0].toUpperCase() + g_oAnnotations.g_oAnnotationColSelected.slice(1)).click();

				g_oAnnotations.initiateAnnotationDraw(result[0], oArtworkCanvas, oAnnotationCanvas);
			};

			addDomElement("asb_" + svgDivID, "input", "img/Freedraw annotation_wht_16.png", "addShapeButton", g_oAnnotations.c_szAnnotationAddShapePrompt, addShapeButtonFunction, oDestination);
			$(".addShapeButton").css("cursor", "pointer"); // IE & Edge don't like this set through the CSS, so force it manually.
		}

		// We allow the colour of the annotation to be changed if:
		// This is not a read only approval.
		// This is an annotation on the main canvas.
		// The user created the annotation, or the annotation is unlocked.
		if (!g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas && (this.g_iAuthor === g_oUserDetails.UserId || this.g_bUnlocked)) {
			// Annotation colour change
			var colourSelectionFunction = function () {
				// define global variable for annotation id.
				g_oAnnotations.g_AnnotationId = origSvgDivID;
		
				// Get the artwork and annotation canvas.
				var oArtworkCanvas = g_oViewer.getCanvas(szArtworkCanvasId);
				var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;
		
				// Call the Select colour
				Annotation.prototype.SelectColourFromDisplay(oAnnotationCanvas);
			};
		
			// If hidden we need to show our colour selection.
			$("scPop_" + svgDivID).show;
			addDomElement("scPop_" + svgDivID, "input", "img/Annotation_colour_16_pb.png", "colourSelection", g_oAnnotations.c_szColourAnnotationText, colourSelectionFunction, oDestination);
			$(".colourSelection").css("cursor", "pointer"); // IE & Edge don't like this set through the css, so force it manually.
		}
		else {
			$("scPop_" + svgDivID).hide;
		}

		// Add text support if:
		// This is not a read only approval.
		// This is an annotation on the main canvas.
		// This is a text based annotation.
		// The user created the annotation, or the annotation is unlocked.
		if (!g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas && (this.g_iAnnotationType == eAnnotationTypes.TextHighlight || this.g_iAnnotationType == eAnnotationTypes.TextClassification) && (this.g_iAuthor === g_oUserDetails.UserId || this.g_bUnlocked)) {

			// Extract the text annotation.
			var oTextAnnotation = this;

			// Outline the add text button function.
			var addTextButtonFunction = function () {

				// Initialise the highlight once the data has been loaded.
				var oAddCallbackAction = function () {
					
					// Set that this will be an addition to an existing annotation.
					g_oTextTools.g_iExistingAnnotationId = oTextAnnotation.id;

					// Set up the existing annotation text.
					g_oTextTools.g_oAnnotationText = JSON.parse(oTextAnnotation.g_szTextHighlightContent);

					// Initialise the highlight.
					g_oTextTools.initialiseTextTool(g_oTextTools.g_eToolTypes.TextHighlight, oTextAnnotation.g_iAnnotationType, JSON.parse(oTextAnnotation.g_szTextHighlightContent)[0].startingText.character != undefined, false, oTextAnnotation.g_szColour);
				};

				// Load the text data.
				g_oTextData.loadTextData(oArtworkCanvas.g_oDoc.documentId, oArtworkCanvas.g_iCurrentPage, true, oAddCallbackAction);
			};

			// Outline the remove text button function.
			var removeTextButtonFunction = function () {

				// Initialise the highlight once the data has been loaded.
				var oRemoveCallbackAction = function () {

					// Set that this will be an addition to an existing annotation.
					g_oTextTools.g_iExistingAnnotationId = oTextAnnotation.id;

					// Set up the existing annotation text.
					g_oTextTools.g_oAnnotationText = JSON.parse(oTextAnnotation.g_szTextHighlightContent);

					// Initialise the highlight.
					g_oTextTools.initialiseTextTool(g_oTextTools.g_eToolTypes.RemoveTextHighlight, oTextAnnotation.g_iAnnotationType, JSON.parse(oTextAnnotation.g_szTextHighlightContent)[0].startingText.character != undefined, false, oTextAnnotation.g_szColour);
				};

				// Load the text data.
				g_oTextData.loadTextData(oArtworkCanvas.g_oDoc.documentId, oArtworkCanvas.g_iCurrentPage, true, oRemoveCallbackAction);
			};

			// Add the buttons.
			addDomElement("atb_" + svgDivID, "input", "img/TextCursor_16 white.png", "addTextButton", "Add Text to Highlight", addTextButtonFunction, oDestination);
			addDomElement("rtb_" + svgDivID, "input", "img/TextCursorRemove_16 white.png", "removeTextButton", "Remove Text from Highlight", removeTextButtonFunction, oDestination);

			// Set the cursors to a pointer.
			$(".addTextButton").css("cursor", "pointer");
			$(".removeTextButton").css("cursor", "pointer");
		}

		// If this is a popup.
		if (type === eAnnotationDivType.Popup) {

			// Add a annotation attachment container for annotation bubble.
			var oAnnotationAttachmentBubbleContainer = document.createElement("div");
			oAnnotationAttachmentBubbleContainer.id = "annotationAttachmentBubble_Container_" + this.id.toString();
			oAnnotationAttachmentBubbleContainer.display = true;
			oDestination.appendChild(oAnnotationAttachmentBubbleContainer);

			// Prevent drag & drop on the attachment list.
			$('#' + oAnnotationAttachmentBubbleContainer.id).on("pointerdown", function (e) {
				e.stopPropagation();
				e.preventDefault();
			});
			$('#' + oAnnotationAttachmentBubbleContainer.id).css('cursor', "default");

			// Render the attachments for this annotation bubble.
			g_oAnnotationAttachments.renderAnnotationAttachments(this.id, "annotationAttachmentBubble_");
		}

		// If this is a list item.
		if (type === eAnnotationDivType.ListItem) {

			// Add a annotation attachment container for list item.
			var oAnnotationAttachmentContainer = document.createElement("div");
			oAnnotationAttachmentContainer.id = "annotationAttachment_Container_" + this.id.toString();
			oAnnotationAttachmentContainer.display = true;
			oDestination.appendChild(oAnnotationAttachmentContainer);
			// render the attachments for this annotation list item.
			g_oAnnotationAttachments.renderAnnotationAttachments(this.id, "annotationAttachment_");

			// Add a hidden annotation audit container.
			var oAnnotationAuditContainer = document.createElement("div");
			oAnnotationAuditContainer.id = this.id + "_annotationAuditContainer";
			oAnnotationAuditContainer.display = false;
			oDestination.appendChild(oAnnotationAuditContainer);

			// Add a hidden annotation data container.
			var oAnnotationDataContainer = document.createElement("div");
			oAnnotationDataContainer.id = this.id + "_annotationDataContainer";
			oAnnotationDataContainer.display = false;
			oDestination.appendChild(oAnnotationDataContainer);
		}
	};

	/**
	 * Apends the annotation status icons to an annotation Div.
	 * @param {string} statusGroupId The status group id assigned to the set of icons getting rendered.
	 * @param {object} destination - The div the icons are getting appended to.
	 * @param {number} annotationStatus - The passed in annotation status
	 * @param {string} svgDivId - The unique id for the Div Id.
	 */
	Annotation.prototype.renderAnnotationStatusIcons = function (statusGroupId, destination, annotationStatus, svgDivId) {
		addDomElement(svgDivId + "_Approved", "input", (annotationStatus == eAnnotationStatuses.Approved ? "img/Status_Approved_Inverted_16.svg" : "img/Status_Approved_White_16.svg"), "fas fa-check addStatusButton approve " + statusGroupId + " Approved_" + statusGroupId, (annotationStatus == eAnnotationStatuses.Approved ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szApproveAnnotation), null, destination, "data-annotationStatus", "Approved");
		addDomElement(svgDivId + "_Rejected", "input", (annotationStatus == eAnnotationStatuses.Rejected ? "img/Status_Rejected_Inverted_16.svg" : "img/Status_Rejected_White_16.svg"), "fas fa-times addStatusButton reject " + statusGroupId + " Rejected_" + statusGroupId, (annotationStatus == eAnnotationStatuses.Rejected ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szRejectAnnotation), null, destination, "data-annotationStatus", "Rejected");
		addDomElement(svgDivId + "_Query", "input", (annotationStatus == eAnnotationStatuses.Query ? "img/Status_Query_Inverted_16.svg" : "img/Status_Query_White_16.svg"), "fas fa-question addStatusButton query " + statusGroupId + " Query_" + statusGroupId, (annotationStatus == eAnnotationStatuses.Query ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szQueryAnnotation), null, destination, "data-annotationStatus", "Query");
		addDomElement(svgDivId + "_ToDo", "input", (annotationStatus == eAnnotationStatuses.ToDo ? "img/Status_ToDo_Inverted_16.svg" : "img/Status_ToDo_White_16.svg"), "fas fa-tasks addStatusButton todo " + statusGroupId + " ToDo_" + statusGroupId, (annotationStatus == eAnnotationStatuses.ToDo ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szTodoAnnotation), null, destination, "data-annotationStatus", "ToDo");
	};

	/**
	 * Updates the status icon tooltips based on the status change.
	 * @param {int} id - The id of the annotation to update the status for.
	 * @param {int} iStatusCode - The active status code.
	 * @param {int} iStatusChangeAction - The status change action.
	 */
	Annotation.prototype.renderAnnotationStatusTooltips = function (id, iStatusCode, iStatusChangeAction) {
		
		// Get a list of annotation approved status icons for this annotation.
		var oApprovedIcons = $(".Approved_statusGroup_" + id);

		// Loop through each of the approved icons.
		for (var i = 0; i < oApprovedIcons.length; i++) {
			var oApprovedIcon = oApprovedIcons[i];

			// The control has already been hovered over by the mouse and Tooltipster has created the custom tooltip and removed the 'title' attribute.
			if ($(oApprovedIcon).hasClass("tooltipstered")) {
				$(oApprovedIcon).tooltipster('content', (iStatusCode == eAnnotationStatuses.Approved && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szApproveAnnotation));
			}
			// The control has not yet been hovered.
			else {
				$(oApprovedIcon).attr("title", (iStatusCode == eAnnotationStatuses.Approved && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szApproveAnnotation));
			}
		}

		// Get a list of annotation rejected status icons for this annotation.
		var oRejectedIcons = $(".Rejected_statusGroup_" + id);

		// Loop through each of the approved icons.
		for (var i = 0; i < oRejectedIcons.length; i++) {
			var oRejectedIcon = oRejectedIcons[i];

			// The control has already been hovered over by the mouse and Tooltipster has created the custom tooltip and removed the 'title' attribute.
			if ($(oRejectedIcon).hasClass("tooltipstered")) {
				$(oRejectedIcon).tooltipster('content', (iStatusCode == eAnnotationStatuses.Rejected && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szRejectAnnotation));
			}
			// The control has not yet been hovered.
			else {
				$(oRejectedIcon).attr("title", (iStatusCode == eAnnotationStatuses.Rejected && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szRejectAnnotation));
			}
		}

		// Get a list of annotation query status icons for this annotation.
		var oQueryIcons = $(".Query_statusGroup_" + id);

		// Loop through each of the approved icons.
		for (var i = 0; i < oQueryIcons.length; i++) {
			var oQueryIcon = oQueryIcons[i];

			// The control has already been hovered over by the mouse and Tooltipster has created the custom tooltip and removed the 'title' attribute.
			if ($(oQueryIcon).hasClass("tooltipstered")) {
				$(oQueryIcon).tooltipster('content', (iStatusCode == eAnnotationStatuses.Query && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szQueryAnnotation));
			}
			// The control has not yet been hovered.
			else {
				$(oQueryIcon).attr("title", (iStatusCode == eAnnotationStatuses.Query && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szQueryAnnotation));
			}
		}

		// Get a list of annotation to do status icons for this annotation.
		var oToDoIcons = $(".ToDo_statusGroup_" + id);

		// Loop through each of the approved icons.
		for (var i = 0; i < oToDoIcons.length; i++) {
			var oToDoIcon = oToDoIcons[i];

			// The control has already been hovered over by the mouse and Tooltipster has created the custom tooltip and removed the 'title' attribute.
			if ($(oToDoIcon).hasClass("tooltipstered")) {
				$(oToDoIcon).tooltipster('content', (iStatusCode == eAnnotationStatuses.ToDo && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szTodoAnnotation));
			}
			// The control has not yet been hovered.
			else {
				$(oToDoIcon).attr("title", (iStatusCode == eAnnotationStatuses.ToDo && iStatusChangeAction != eAnnotationStatusUpdateType.deleteStatus ? g_oAnnotations.c_szRemoveStatus : g_oAnnotations.c_szTodoAnnotation));
			}
		}
	};

	/**
	 * Generates the annotation header details.
	 * @param {int} iType - The type of annotation we are creating.
	 * @param {string} szCreatorEmail - The email address of the creator.
	 * @param {string} szCreatorDisplayName - The display name of the creator.
	 * @param {object} oDate - The date.
	 * @returns {object} - The created annotation header .
	 */
	var generateAnnotationHeaderDetails = function (iType, szCreatorEmail, szCreatorDisplayName, oDate) {

		// Create the header element.
		var oAnnHeader = document.createElement("p");

		// Add the display name.
		oAnnHeader.innerHTML = g_oAnnotations.getDisplayName(szCreatorEmail, szCreatorDisplayName);

		// If we have a date, add this.
		if (!!oDate) {
			oAnnHeader.innerHTML += " " + formatDate(oDate);
		}

		// Add the status field if this is a status header.
		if (iType == eFieldTypes.StatusHeader) {
			oAnnHeader.innerHTML = "<span data-statusfield='statusAuthor'>" + oAnnHeader.innerHTML + "</span>";
		}

		// Set the relevant CSS stylings.
		var szHeaderClass;
		switch (iType) {
			case eFieldTypes.StatusHeader: szHeaderClass = "HeaderTextStatus"; break;
			case eFieldTypes.ReplyHeader: szHeaderClass = "HeaderTextReply"; break;
			default: szHeaderClass = "HeaderText"; break;
		}

		// Add the class name.
		oAnnHeader.className = szHeaderClass;

		// Return the header.
		return oAnnHeader;
	};

	/**
	 * Generates the header containing details + buttons that appears above the annotation text.
	 * @param {number} iType - (eFieldTypes) The type of header to be created
	 * @param {string} szCreatorEmail - The email corresponding of the annotation creator.
	 * @param {string} szCreatorDisplayName - The display name of the annotation creator.
	 * @param {object|null} oDate - The date to be rendered (if desired).
	 * @param {number} dbId - The ID of the annotation as saved in the database.
	 * @param {object} oArtworkCanvas - Object containing artwork canvas.
	 * @param {boolean} bExistingAnnotation - Whether this annotation already exists.
	 * @param {boolean} bMyAnnotation - Does this annotation belong to the user signed in?
	 * @param {boolean} bInFlyout - Is this being rendered in the flyout?
	 * @returns {object} Returns DOM object
	 */
	var generateAnnotationHeader = function (iType, szCreatorEmail, szCreatorDisplayName, oDate, dbId, oArtworkCanvas, bExistingAnnotation, bMyAnnotation, bInFlyout) {
		var oHeaderContainer = document.createElement("span");

		var bShowDate = dbId > 0 || iType === eFieldTypes.StatusHeader;
		var oDetails = generateAnnotationHeaderDetails(iType, szCreatorEmail, szCreatorDisplayName, bShowDate ? oDate : null);
		oHeaderContainer.appendChild(oDetails);

		// Buttons are to appear within the <p> element created previously.
		oHeaderContainer = oDetails;

		var oButtons = generateAnnotationHeaderButtons(iType, dbId, oArtworkCanvas, bExistingAnnotation, bMyAnnotation, bInFlyout);
		oHeaderContainer.appendChild(oButtons);

		return oHeaderContainer;
	};

	/**
	 * Generates the relevant buttons to show alongside the annotation.
	 * @param {number} iType - (eFieldTypes) The type of header to be created
	 * @param {number} dbId - The ID of the annotation as saved in the database.
	 * @param {object} oArtworkCanvas - Object containing artwork canvas.
	 * @param {boolean} bExistingAnnotation - Whether this annotation already exists.
	 * @param {boolean} bMyAnnotation - Does this annotation belong to the user signed in?
	 * @param {boolean} bInFlyout - Is this being rendered in the flyout?
	 * @returns {object} Returns DOM object
	 */
	var generateAnnotationHeaderButtons = function (iType, dbId, oArtworkCanvas, bExistingAnnotation, bMyAnnotation, bInFlyout) {
		var oButtonsContainer = document.createElement("span");
		oButtonsContainer.setAttribute("data-artworkCanvas", oArtworkCanvas.g_szCanvasId);

		// Create the 'delete annotation reply' button.
		// This should only be visible on annotation replies if the approval is active on the main canvas AND EITHER it's our annotation reply OR if we're creating a new reply.
		if (!g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas && (bMyAnnotation || !bExistingAnnotation) && iType === eFieldTypes.ReplyHeader) {
			var szClassName = bExistingAnnotation ? "deleteAnnotationReplyButton" : "cancelAnnotationReplyButton";
			var szHoverText = bExistingAnnotation ? g_oAnnotations.c_szDeleteAnnotationReply : "Cancel Annotation Reply";
			var szButtonId = dbId + "_del_reply" + (bInFlyout ? "_li" : "");
			addDomElement(szButtonId, "input", "img/Delete_wht_16.png", szClassName, szHoverText, null, oButtonsContainer);
		}

		return oButtonsContainer;
	};

	/**
	 * Create an active text area for use in an annotation and appends it to the target.
	 * @param {string} SVGDivId - The div that the text area is being created in.
	 * @param {number} iType - (eFieldTypes) The type of annotation header.
	 * @param {number} dbId - The ID of the annotation as saved in the database.
	 * @param {string} textContent - The contents of the annotation.
	 * @param {object} oArtworkCanvas - Object containing artwork canvas.
	 * @param {object} oAnnotationCanvas - Object containing annotation canvas.
	 * @param {object} oJQTEOptionsOverride - Object containing JQTE override options.
	 * @param {object} szJQTEBackgroundColourOverride - Object containing JQTE background colour override.
	 * @param {object} oCurrentAnnotation - The current annotation.
	 * @param {object} target - The target container.
	 * @returns {object} Returns a generated DOM object that may be appended as a child.
	 */
	var createTextAreaInputActive = function (SVGDivId, iType, dbId, textContent, oArtworkCanvas, oAnnotationCanvas, oJQTEOptionsOverride, szJQTEBackgroundColourOverride, oCurrentAnnotation, target) {
		var input = document.createElement("textarea");

		if (iType === eFieldTypes.AnnotationMainHeader) {
			input.className = "Original";
		}
		else {
			input.className = "Reply";
			$("#rb_" + $(target).parent().attr("id")).hide();
		}

		input.id = SVGDivId;
		input.size = 36;

		if (dbId !== undefined) {
			input.setAttribute("data-annotationreplyid", dbId);
		}

		if (textContent !== undefined) {
			input.value = textContent;
			// Store a copy of the old content.
			g_oAnnotations.g_szAnnotationContent = input.value;
		}

		target.appendChild(input);

		// If this is a NEW annotation, turn off the events that draw annotations.
		if (dbId < 0) {
			$("#AnnotationViewer").off("pointerdown");
			$("#AnnotationViewer").off("pointerup");
		}

		// Outline the JQTE options.
		var oJQTEOptions = {
			"br": true,
			"center": false,
			"color": false,
			"format": false,
			"indent": false,
			"link": false,
			"left": false,
			"outdent": false,
			"ol": false,
			"p": false,
			"remove": false,
			"right": false,
			"rule": false,
			"source": false,
			"title": false,
			"unlink": false
		};

		// If we have a JQTE options override, use this instead.
		if (oJQTEOptionsOverride !== null) {
			oJQTEOptions = oJQTEOptionsOverride;
		}

		// TE will automatically escape tags that are entered by the user.
		$(input).jqte(oJQTEOptions);

		$(".jqte_editor").attr("dir", "auto");

		// If we have a JQTE background colour override, use this.
		if (szJQTEBackgroundColourOverride !== null) {
			$(".jqte_editor").addClass(szJQTEBackgroundColourOverride);
		}

		// If we have custom options for the JQTE text editor.
		if (oJQTEOptionsOverride !== null) {
			
			// Disable the keyboard shortcuts.
			$(".jqte_editor").attr("data-disableshortcuts", "true");
		}

		$(".jqte_editor").on("pointerdown", function (e) {
			e.stopPropagation();
		});

		$(".jqte_editor").on("pointermove", function (e) {
			e.stopPropagation();
			$(".speechbubble").off("pointerup");
		});
		
		// Only set the lose focus if this is not a difference type.
		if (iType != eFieldTypes.DifferenceHeader) {
			$(".jqte_editor").on("focus", function (e) {
				changeCanvasFunction("#AnnotationViewer", "pointerdown", function (e) {
					oCurrentAnnotation.AnnotationTextEditorLooseFocusEvent(e, oCurrentAnnotation, input, oArtworkCanvas, oAnnotationCanvas);
				});
			});
		}

		return input;
	};

	/**
	 * Creates a disabled text area for use in an annotation and appends it to the target.
	 * @param {number} iType - (eFieldTypes) The type of annotation header.
	 * @param {number} dbId - The ID of the annotation as saved in the database.
	 * @param {string} szCreator - The email address of the creator
	 * @param {string} textContent - The contents of the annotation.
	 * @param {object} oArtworkCanvas - Object containing artwork canvas.
	 * @param {object} oAnnotationCanvas - Object containing annotation canvas.
	 * @param {object} oCurrentAnnotation - The current annotation.
	 * @param {object} target - The target container.
	 * @returns {object} Returns a generated DOM object that may be appended as a child.
	 */
	var createTextAreaInputDisabled = function (iType, dbId, szCreator, textContent, oArtworkCanvas, oCurrentAnnotation, target) {
		
		var input = document.createElement("p");
		if (dbId !== undefined) {
			input.setAttribute("data-dbId", dbId);
		}

		input.id = "_p" + oCurrentAnnotation.id; // svg id
		if (iType === eFieldTypes.AnnotationMainHeader) {
			input.className = "ReadOnlyAnnotationText";
		}
		else if (iType === eFieldTypes.StatusHeader) {
			input.className = "status";
			input.setAttribute("data-statusfield", "statusValue");
			input.setAttribute("data-authorid", szCreator);
		}
		else {
			input.className = "ReadOnlyReplyText";
		}

		// Determin if this is a list item or popup.
		var bListItem = ($(target).parents(".annotationListItem").length > 0);

		// If this is an SVG annotation.
		if (oCurrentAnnotation.g_bSVGTextAnnotation) {

			// Get the unformatted text from the text content.
			textContent = g_oSVGText.getUnformattedSVGText(textContent);
		}

		input.innerHTML = textContent;

		// Internet Explorer 6-11
		var bIE = false || !!document.documentMode;
		// Edge 20+
		var bEdge = !bIE && !!window.StyleMedia;
		if (!bIE && !bEdge) {
			input.dir = "auto";
		}

		$(".speechbubble").off('copy');
		$(".speechbubble").on('copy', function (event) { AnnotationUI.prototype.copyOverride(event); });

		// We show the edit option if the user has an open approval slot and this is not a new annotation or an annotation status.
		// And they created the annotation, this is an unlocked annotation, or this is an svg text annotation which the user has permissions to edit.
		if (oCurrentAnnotation.g_iApprovalId === g_oAnnotations.g_iApprovalId && !g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas && oCurrentAnnotation.id > 0 && iType != eFieldTypes.StatusHeader) {
			if ((szCreator === g_oUserDetails.UserId || oCurrentAnnotation.g_bUnlocked) || (oCurrentAnnotation.g_bSVGTextAnnotation && iType != eFieldTypes.ReplyHeader && g_oUserDetails.CreateTextEditing)) {
				addDomElement("eb_" + (bListItem ? "li_" : "") + input.id + "_" + dbId, "input", "img/Edit_Wht_16.png", "editAnnotationTextButton", g_oAnnotations.c_szEditAnnotationText, EditButtonOnClick, input);
			}
		}

		// Append the child.
		target.appendChild(input);

		// Return the input.
		return input;
	};

	/**
	 * Creates the text area for an annotation area. Uses jQuery TE for functionality.
	 * @param {string} SVGDivId - The Div Id.
	 * @param {number} creator - The User ID of the Creator.
	 * @param {string} creatorEmail - The email of the creator.
	 * @param {string} creatorDisplayName - The display name of the creator.
	 * @param {number} type - (eFieldTypes) The type of header we are creating.
	 * @param {bool} readOnly - Is it read only?
	 * @param {string} textContent - The content of the annotation
	 * @param {string} target - The div to create the target to.
	 * @param {object} date - The date of the annotation (moment.js object).
	 * @param {number} dbId - The ID of the annotation as saved in the database.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 * @param {object} oJQTEOptionsOverride - The override for the JQTE options.
	 * @param {object} szJQTEBackgroundColourOverride - The override for the JQTE background colour.
	 */
	Annotation.prototype.createAnnotationTextArea = function (SVGDivId, creator, creatorEmail, creatorDisplayName, type, readOnly, textContent, target, date, dbId, oArtworkCanvas, oAnnotationCanvas, oJQTEOptionsOverride, szJQTEBackgroundColourOverride) {

		// Ensure the div id is a string.
		SVGDivId = "" + SVGDivId;

		// If this is a difference type, only create the active text area.
		if (type == eFieldTypes.DifferenceHeader) {
			createTextAreaInputActive(SVGDivId, type, dbId, textContent, oArtworkCanvas, oArtworkCanvas, oJQTEOptionsOverride, szJQTEBackgroundColourOverride, oCurrentAnnotation, target);
			return;
		}

		// If this is a copy magic type, only create the active text area.
		if (type == eFieldTypes.CopyMagic) {
			createTextAreaInputActive(SVGDivId, type, dbId, textContent, oArtworkCanvas, oArtworkCanvas, oJQTEOptionsOverride, szJQTEBackgroundColourOverride, oCurrentAnnotation, target);
			return;
		}

		// Extract the current annotation.
		var oCurrentAnnotation = this;
        $('#AnnotationViewer').css("cursor", "default");
        g_oAnnotations.g_szPrevCursorStyle = "default";

		// Ensure we have a target.
		if (target === null) {
			return;
		}

		// Create a child div, insert into target then make this the new target.
		var oContentContainer = document.createElement("div");
		target.appendChild(oContentContainer);
		target = oContentContainer;

		// Create annotation header and insert into container.
		var bIsMyAnnotation = creator === g_oUserDetails.UserId;
		var bInFlyout = !SVGDivId || SVGDivId.indexOf("li") >= 0;
		var szAnnotationHeader = generateAnnotationHeader(type, creatorEmail, creatorDisplayName, date, dbId, oArtworkCanvas, !!textContent, bIsMyAnnotation, bInFlyout);
		target.appendChild(szAnnotationHeader);

		// If this is a text classification annotation, add the text classification details.
		if (type === eFieldTypes.AnnotationMainHeader && oCurrentAnnotation.g_iAnnotationType == eAnnotationTypes.TextClassification) {
			g_oAnnotationTextClassification.renderAnnotationTextClassificationContent(oCurrentAnnotation, oArtworkCanvas, target);
		}

		// Generate text area input and append result into target container.
		var input;
		if (!readOnly) {
			input = createTextAreaInputActive(SVGDivId, type, dbId, textContent, oArtworkCanvas, oArtworkCanvas, oJQTEOptionsOverride, szJQTEBackgroundColourOverride, oCurrentAnnotation, target);
		}
		else {
			input = createTextAreaInputDisabled(type, dbId, creator, textContent, oArtworkCanvas, oCurrentAnnotation, target);
		}
		$(".jqte_editor").focus();

		// If this is an svg annotation, ensure focus is correctly applied after rich text is loaded.
		if (oCurrentAnnotation.g_bSVGTextAnnotation) {
			setTimeout(function () { $(".jqte_editor").focus(); }, 500);
			// If this is a brand new annotation popup, ensure we are scrolled to the top.
			if (dbId < 0 && type === eFieldTypes.AnnotationMainHeader && !readOnly) {
				setTimeout(function () { $(target).parent().scrollTop(0); }, 600);
			}
		}

		// Override the pointer up event.
		$("#" + input.id).on("pointerup", function () {
			if (oArtworkCanvas.g_oDoc.documentType === eDocumentTypes.ThreeD) {
				g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
				oArtworkCanvas.g_oRenderer.render(oArtworkCanvas.g_oScene, oArtworkCanvas.g_oCamera);
			}
			else {
				oArtworkCanvas.redraw(false);
			}
		});
	};

	/**
	 * Event executed when the text editor looses focus.
	 * @param e {object} - The focus Event.
	 * @param oCurrentAnnotation {object} - The current annotation object.
	 * @param input {object} - The element that has lost focus.
	 * @param oArtworkCanvas {object} - The current artwork canvas.
	 * @param oAnnotationCanvas {object} - The current annotation canvas.
	 */
	Annotation.prototype.AnnotationTextEditorLooseFocusEvent = function (e, oCurrentAnnotation, input, oArtworkCanvas, oAnnotationCanvas) {
		var _this = this;

		// If we have no input, return.
		if (input && input.value === "") {
			return;
		}

		// Determine the caller type as either a list item or pop-up.
		var callerType = eAnnotationDivType.Popup;
		if ($(".jqte_editor").parents(".annotationListItem").length > 0) {
			callerType = eAnnotationDivType.ListItem;
		}

		// Determine if this is an original annotation or a reply.
		var bReply = false;
		if (_this.g_iParentAnnotationId > 0 ||
			(callerType == eAnnotationDivType.ListItem && $(".jqte_editor").parents("#rc_li_" + _this.id).length > 0) ||
			(callerType == eAnnotationDivType.Popup && $(".jqte_editor").parents("#rc_" + _this.id).length > 0)) {
			bReply = true;
		}

		// Get the input div and annotation div.
		var oInputDiv = null
		var oAnnotationDiv = null;
		
		// If this is an original list item.
		if (callerType == eAnnotationDivType.ListItem && bReply == false) {

			// Get the text input.
			oInputDiv = $("#tili_" + _this.id)[0];

			// Get the annotations div.
			oAnnotationDiv = $(".jqte_editor").parents(".annotationListItem")[0];
		}
		// If this is an reply list item.
		else if (callerType == eAnnotationDivType.ListItem && bReply == true) {
			
			// If this is an existing reply.
			if (_this.g_iParentAnnotationId > 0) {

				// Get the parent annotation object.
				var oParentAnnotationObject = $.grep(g_oAnnotations.g_oAnnotationsMade, function (annotation) { return annotation.id == _this.g_iParentAnnotationId; });

				// Get the text input.
				oInputDiv = $("#ar_" + "li_" + oParentAnnotationObject[0].id)[0];
			}
			// If this is a new reply.
			else {
				// Get the correct text input.
				oInputDiv = typeof $("#ar_li_" + _this.id)[0] === "undefined" ? $("#ar_" + _this.id)[0] : $("#ar_li_" + _this.id)[0];
			}

			// Get the annotations div.
			oAnnotationDiv = $(".jqte_editor").parents(".annotationListItem")[0];
		}
		// If this is an original pop-up.
		else if (callerType == eAnnotationDivType.Popup && bReply == false) {

			// Get the text input.
			oInputDiv = $("#ti" + _this.id)[0];

			// Get the annotations div.
			oAnnotationDiv = $(".jqte_editor").parents(".annotation")[0];
		}
		// If this is an reply pop-up.
		else if (callerType == eAnnotationDivType.Popup && bReply == true) {
			
			// If this is an existing reply.
			if (_this.g_iParentAnnotationId > 0) {

				// Get the parent annotation object.
				var oParentAnnotationObject = $.grep(g_oAnnotations.g_oAnnotationsMade, function (annotation) { return annotation.id == _this.g_iParentAnnotationId; });

				// Get the text input.
				oInputDiv = $("#ar_" + oParentAnnotationObject[0].id)[0];
			}
			// If this is a new reply.
			else {
				// Get the correct text input.
				oInputDiv = typeof $("#ar_li_" + _this.id)[0] === "undefined" ? $("#ar_" + _this.id)[0] : $("#ar_li_" + _this.id)[0];
			}

			// Get the annotations div.
			oAnnotationDiv = $(".jqte_editor").parents(".annotation")[0];
		}
		
		// There is an unsaved annotation and we've clicked OUTSIDE the annotation and OUTSIDE the JQTE text editor.
		if (g_oAnnotations.checkForUnsavedAnnotation() && oInputDiv != null && oAnnotationDiv !== null && !oAnnotationDiv.contains(e.target) && $(e.target).parents(".jqte_focused").length == 0) {
			// See if Move to own function.
			// Check the user has a valid approval session and that the doc is the one under approval
			if (g_oAnnotations.c_szSessionId !== 0 && _this.g_iApprovalId === g_oAnnotations.g_iApprovalId) {
				e.stopPropagation();
			}

			// Grab the actual input and replace line breaks with spaces.
			var szRaw = $(".jqte_editor").html().replace(/\n/g, ' ');
			oInputDiv.value = szRaw;

			// If this is a single break due to an edge bug, set this as blank.
			if (oInputDiv.value === "<br>") {
				oInputDiv.value = "";
			}

			// Escape HTML to check for empty comments.
			var szInputValueText = oInputDiv.value.replace(/(<([^>]+)>)/ig, "");

			// We now need to check on whether or not this is a reply or an annotation being saved.
			if (!bReply) {

				// Find the resulting annotation.
				var result = $.grep(g_oAnnotations.g_oAnnotationsMade, function (ann) {
					return ann.id == _this.id;
				});

				// Only save if the input has changed and it isn't blank.
				if (((oInputDiv.value != _this.g_szTextContent) && szInputValueText != "") || // Has the annotation content changed?
					((_this.g_iAnnotationType === eAnnotationTypes.TextMeasurement) && !_this.g_bSaved) || // Or is the annotation a new Text Measurement?
					((_this.g_iAnnotationType === eAnnotationTypes.TextHighlight) && !_this.g_bSaved) || // Or is the annotation a new Text Highlight?
					((_this.g_iAnnotationType === eAnnotationTypes.TextClassification) && !_this.g_bSaved) || // Or is the annotation a new Text Classification?
					(oInputDiv.value != "" && !_this.g_bSaved)) { // Or is it a new annotation without empty text?

					// Set the correct annotation status.
					result[0].status = result[0].status == "a" ? result[0].status = "a" : result[0].status = "u";

					// Update the JQTE value.
					$(".jqte_editor").jqteVal(oInputDiv.value);

					// Save the annotation.
					result[0].AnnotationSave(callerType, oArtworkCanvas, oAnnotationCanvas, true);

					// Remove the PointerDown event to allow other controls to register click events.
					$(document).off("pointerdown");
				}
				// Reset the div to read only, if we haven't changed the text and it isn't blank.
				else if (oInputDiv.value != "") {
					g_oAnnotations.rebuildAnnotationList(oArtworkCanvas, oAnnotationCanvas);
					g_oAnnotations.initiateAnnotationDraw(0, oArtworkCanvas, oAnnotationCanvas);
				}
			}
			// If this is a reply.
			else if (bReply) {

				// Same as above, but save the current annotation, not the result.
				for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {
					var result = $.grep(g_oAnnotations.g_oAnnotationsMade[i].g_oReplies, function (reply) {
						return reply.id == oInputDiv.getAttribute("data-annotationreplyid");
					});
					if (result.length > 0) {
						break;
					}
				}

				// New reply, so check that isn't blank.
				if (result.length == 0 && oInputDiv.value != "") {

					// Create new annotation reply.
					var oNewAnnotation = new Annotation(g_oAnnotations.g_iApprovalId);
					oNewAnnotation.id = parseInt(oInputDiv.getAttribute("data-annotationreplyid")) || g_oAnnotations.getNextAnnotationId();
					oNewAnnotation.g_szColour = _this.g_szColour;
					oNewAnnotation.g_iAnnotationType = _this.g_iAnnotationType;
					oNewAnnotation.g_iParentAnnotationId = _this.id;
					oNewAnnotation.g_iDocumentId = _this.g_iDocumentId;
					oNewAnnotation.g_iDocumentPageId = _this.g_iDocumentPageId;
					oNewAnnotation.g_iAuthor = g_oUserDetails.UserId;
					oNewAnnotation.g_szAuthorEmail = g_oUserDetails.EmailAddress;
					oNewAnnotation.g_szTextContent = oInputDiv.value;
					oNewAnnotation.g_bSaved = true;
					oNewAnnotation.status = "a";

					// Set the parent to update.
					_this.status = "u";

					// Push the new reply into the reply array.
					_this.g_oReplies.push(oNewAnnotation);

					// Update the JQTE value.
					$(".jqte_editor").jqteVal(oInputDiv.value);

					// Save the annotation reply.
					oCurrentAnnotation.AnnotationSave(0, oArtworkCanvas, oAnnotationCanvas, false);

					// Remove the PointerDown event to allow other controls to register click events.
					$(document).off("pointerdown");
				}
				// Otherwise check the replies for change.
				else if ((oInputDiv.value != result[0].g_szTextContent) && oInputDiv.value != "") {

					// Update the existing annotation with the new values.
					result[0].g_szTextContent = oInputDiv.value;
					result[0].status = "u";

					// Update the JQTE value.
					$(".jqte_editor").jqteVal(oInputDiv.value);

					// Save the annotation.
					_this.AnnotationSave(0, oArtworkCanvas, oAnnotationCanvas, false);

					// Remove the PointerDown event to allow other controls to register click events.
					$(document).off("pointerdown");
				}
				// If there is no change and it's blank, reset the list.
				else if (oInputDiv.value != "") {
					
					var resultParent = $.grep(g_oAnnotations.g_oAnnotationsMade, function (ann) {
						return ann.id == result[0].g_iParentAnnotationId;
					});

					result[0].g_bSaved = true;
					resultParent[0].g_bSaved = true;

					// If we have an open popup for this annotation, close it.
					if ($("#" + resultParent[0].id + "_clo").length > 0) {
						$("#" + resultParent[0].id + "_clo").click();
					}

					if (g_oViewer.g_oArtworkViewer.g_oDoc.documentType !== eDocumentTypes.ThreeD) {
						g_oAnnotations.rebuildAnnotationList(oArtworkCanvas, oAnnotationCanvas);
						g_oAnnotations.initiateAnnotationDraw(0, oArtworkCanvas, oAnnotationCanvas);
					}
					else {
						// Artwork Canvas is actually the Annotation Canvas at this point, so swap these around.
						oAnnotationCanvas = oArtworkCanvas;
						oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);
						g_oAnnotations.rebuildAnnotationList(oArtworkCanvas, oAnnotationCanvas);
						g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
					}
				}
			}
		}

		// Prevent default behaviour and bubbling.
		e.preventDefault();
		e.stopPropagation();
	},

	/**
	 * Convert 3D co-ordinates to 2D Coordinates for placing pop-ups.
	 * @param {array} position - The current position in 3D.
	 * @returns {array} - An array of co-ordinates
	 */
	Annotation.prototype.threeDToTwoDCoords = function (position, oArtworkCanvas, oAnnotationCanvas) {
		var p = new THREE.Vector3(position.x, position.y, position.z);
		var vector = p.project(oArtworkCanvas.g_oCamera);

		vector.x = (vector.x + 1) / 2 * oArtworkCanvas.g_oCanvas.clientWidth;
		vector.y = -(vector.y - 1) / 2 * oArtworkCanvas.g_oCanvas.clientHeight;
		return vector;
	},

	/**
	 * Saves or updates an annotation.
	 * @param {int} callerType - Whether the annotation is being saved from the list or the pop-up div. If 1, it's saved from the list.
	 * @param {object} oArtworkCanvas - The artwork canvas.
	 * @param {object} oAnnotationCanvas - The annotation canvas.
	 * @param {bool} bIsMainAnnotation - If we are saving the main annotation.
	 */
	Annotation.prototype.AnnotationSave = function (callerType, oArtworkCanvas, oAnnotationCanvas, bIsMainAnnotation) {
		
		// Get the selected document from the combo control.
		var oDocument = g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex];

		// If we are dealing with a 3d view annotation then the variables below will be populated.
		var bNewThreeDViewAnnotation = oDocument.document.Approval3DViewId > 0;
		var oThreeDViewParentDocument = null;
		var iParentDocumentId = -1;
		var iParentDocumentPageId = -1;
		var szModelPath = "";
		var szModelPrimaryArtworkTexture = "";
		var iThreeDViewdocumentId = -1;

		// Determine if this is a new copy magic text annotation.
		var oNewCopyMagicTextAnnotation = this.g_bSVGTextAnnotation && this.g_oSVGVariable.copyMagicText && this.status == "a" ? this.g_oSVGVariable : null;

		// Check we are not already processing a new annotation.
		if (this.id < 0 && $("#" + this.id.toString() + "_del").attr("src") == "img/WhiteSpinner24.gif") {
			return;
		}

		// Switch Delete Icon to Loading Spinner if this is a new annotation and this is NOT a read only Text Measurement annotation.
		if (!(g_oViewer.g_bReadOnly && this.g_iAnnotationType === eAnnotationTypes.TextMeasurement && this.id < 0)) {
			swapImage(this.id.toString() + "_del", "img/WhiteSpinner24.gif");
		}

		// Populate 3D View metadata when adding an annotation to a 3D view
		if (bNewThreeDViewAnnotation) {
			// 3D view and model details
			iThreeDViewdocumentId = oDocument.document.documentId;
			var oThreeDView = g_oThreeDView.GetThreeDView(oDocument.document.Approval3DViewId);
			szModelPrimaryArtworkTexture = GetFileNameWithoutExtension(oThreeDView.ModelTemplatePrimaryArtworkFileName);
			szModelPath = oThreeDView.ModelTemplatePath + '\\' + oThreeDView.ModelTemplateName;
			iThreeDViewdocumentId = oDocument.document.documentId;

			// Parent details
			iParentDocumentId = oThreeDView.ParentDocumentId;
			iParentDocumentPageId = oThreeDView.ParentDocumentPageId;
			oThreeDViewParentDocument = $.findfirst(g_oaComboControls[0].documents, function (x) {
				return x.greenlightDocumentId === iParentDocumentId;
			}).document;
		}

		// Note the scroll position of the list before the re-render.
		var iListScrollTop = $("#divAnnDiv_ListItems").scrollTop();

		// Turn off the jqte editor.
		$(".jqte_editor").off();

		// Return any linked shape annotations (i.e. linked to parent annotation pop-up)
		// For some reason JQuery grep does not work with properties
		// So create a variable for it instead
		var _this = deepCopyObject(this);

		// Reset dirty state
		this.dirtystate = false;

		// Determine the prefix to be added.
		var prefix = (callerType === eAnnotationDivType.ListItem) ? "li_" : "";

		// Grab the text content for the parent annotation.
		var newTextContent = $("#" + "ti" + prefix + this.id).val();
		if (newTextContent) {
			this.g_szTextContent = newTextContent;
		}

		// Set the modified date if required.
		if (this.modifiedDate == null || this.modifiedDate < new Date()) {
			this.modifiedDate = new Date();
		}

		// Set up the replies
		var annotationReplies = [];
		for (var i = 0; i < this.g_oReplies.length; i++) {
			// As the reply will mostly the same as the parent, copy the Annotation to hold the reply.
			// Create a cut down version of the Reply object to be passed to the server.
			// This is the same as the actual annotation, but updated with the relevant information.
			var oReplyObject = {
				annotationId: this.g_oReplies[i].id,
				approvalId: this.g_oReplies[i].g_iApprovalId,
				approvalUserId: g_oUserDetails.UserId,
				approvalUserEmailAddress: this.g_oReplies[i].g_szAuthorEmail,
				documentId: bNewThreeDViewAnnotation ? iParentDocumentId : this.g_iDocumentId,
				documentPageId: bNewThreeDViewAnnotation ? iParentDocumentPageId : this.g_oReplies[i].g_iDocumentPageId,
				replyToAnnotId: this.g_oReplies[i].g_iParentAnnotationId,
				annotationType: bNewThreeDViewAnnotation ? 0 : this.g_oReplies[i].g_iAnnotationType,
				annotationDateTime: "",
				modifiedDateTime: "",
				svgVariableId: JSON.stringify(this.g_oReplies[i].g_oSVGVariable),
				svgOriginalContent: this.g_oReplies[i].g_szSVGOriginalContent,
				textHighlightContent: this.g_oReplies[i].g_szTextHighlightContent,
				annotationContent: this.g_oReplies[i].g_szTextContent,
				annotationColour: g_oAnnotations.getHexColour(this.g_oReplies[i].g_szColour) || this.g_oReplies[i].g_szColour,
				annotationData: this.g_oReplies[i].g_oAnnotationData == null ? "" : JSON.stringify(this.g_oReplies[i].g_oAnnotationData),
				unlocked: false,
				deleted: false,
				status: this.g_oReplies[i].status,
				annotationStatuses: [],
				annotationCoords: []
			};

			annotationReplies.push(oReplyObject);
		}
		
		// Create the array co-ordinates for the annotations.
		var annotationCoords = [];
		for (var i = 0; i < this.g_oDrawArray.length; i++) {
			var oAnnotationCoordObject = {
				annotationId: this.id,
				annotationX: this.g_oDrawArray[i][0],
				annotationY: this.g_oDrawArray[i][1],
				annotationZ: this.g_oDrawArray[i][2] !== undefined ? this.g_oDrawArray[i][i + 2] : null,
				annotation3dvUVx: this.g_iuvX,
				annotation3dvUVy: this.g_iuvY,
				marqueeX: null,
				marqueeY: null
			};

			if (this.g_iAnnotationType === eAnnotationTypes.TextMeasurement &&
				this.g_oMarqueeDrawArray.length > 0) {
				oAnnotationCoordObject.marqueeX = this.g_oMarqueeDrawArray[i][0];
				oAnnotationCoordObject.marqueeY = this.g_oMarqueeDrawArray[i][1];
			}

			annotationCoords.push(oAnnotationCoordObject);
		}

		// We have a duplicate annotation! Return so we don't save it.
		if (g_oAnnotations.g_oPreviouslySavedAnnotationCoords == annotationCoords) {
			return;
		}

		// Update the previous Annotation coordinates to the new set that we're about to save.
		g_oAnnotations.g_oPreviouslySavedAnnotationCoords = deepCopyArray(annotationCoords);

		// If this is an SVG text annotation.
		if (this.g_bSVGTextAnnotation) {
			
			// If the main annotation has been updated.
			if (bIsMainAnnotation && this.status == "u") {

				// Reset any statuses on the annotation.
				g_oAnnotations.resetAnnotationStatus(this, oArtworkCanvas, oAnnotationCanvas);
			}

			// Apply the SVG text update.
			g_oSVGText.applySVGTextUpdate(this.g_oSVGVariable, this.g_szTextContent, oArtworkCanvas, oAnnotationCanvas);
		}

		// If this is a new text classification annotation, update the annotation data.
		if (this.g_iAnnotationType === eAnnotationTypes.TextClassification && this.id < 0) {
			g_oAnnotationTextClassification.updateAnnotationTextClassificationData(this, false);
		}

		// Create a cut down version of the Annotation object to be passed to the server.
		var oAnnotationObject = {
			annotationId: this.id,
			approvalId: this.g_iApprovalId,
			approvalUserId: this.g_iAuthor,
			approvalUserEmailAddress: this.g_szAuthorEmail,
			documentId: bNewThreeDViewAnnotation ? iParentDocumentId : this.g_iDocumentId,
			documentPageId: bNewThreeDViewAnnotation ? iParentDocumentPageId : this.g_iDocumentPageId,
			replyToAnnotId: this.g_iParentAnnotationId,
			annotationType: bNewThreeDViewAnnotation ? 0 : this.g_iAnnotationType,
			annotationDateTime: "",
			modifiedDateTime: "",
			svgVariableId: JSON.stringify(this.g_oSVGVariable),
			svgOriginalContent: this.g_szSVGOriginalContent,
			textHighlightContent: this.g_szTextHighlightContent,
			annotationContent: this.g_szTextContent,
			annotationColour: g_oAnnotations.getHexColour(this.g_szColour) || this.g_szColour,
			annotationData: this.g_oAnnotationData == null ? "" : JSON.stringify(this.g_oAnnotationData),
			unlocked: false,
			deleted: false,
			status: this.status,
			annotationReplies: annotationReplies,
			annotationStatuses: this.g_oStatuses,
			annotationCoords: annotationCoords,
			attachments: this.attachments
		};

		// Determine if we have a compare document.
		var iCompareDocumentId = 0;

		// If we are in a compare mode, include the annotations for the compare document if a different document has been selected.
		if (g_oViewer.g_oCompareMode != eCompareMode.NoCompare && oAnnotationObject.documentId != g_oCompare.g_oCompareDocument.document.documentId) {
			iCompareDocumentId = g_oCompare.g_oCompareDocument.document.documentId;
		}

		// ThreeDView annotations handled in Greenlight3dView.js
		if (bNewThreeDViewAnnotation) {
			g_oThreeDView.AddThreeDViewAnnotation(this.g_iApprovalId, g_oUserDetails.UserId, g_oAnnotations.c_szSessionId, g_oUserDetails.ThirdParyMemberId, iCompareDocumentId, oAnnotationObject, oThreeDViewParentDocument, iParentDocumentPageId, szModelPath, szModelPrimaryArtworkTexture, iThreeDViewdocumentId, _this.id);
		}
		else {
			// Build up the annotation string.
			var oJSON = {
				iApprovalId: this.g_iApprovalId,
				iApprovalUserId: g_oUserDetails.UserId,
				iCompareDocumentId: iCompareDocumentId,
				szSessionId: g_oAnnotations.c_szSessionId,
				szThirdPartyMemberId: g_oUserDetails.ThirdParyMemberId,
				oAnnotation: oAnnotationObject
			};

			$.ajax({
				type: "POST",
				url: "internal/GreenlightAnnotation/SaveAnnotation",
				data: JSON.stringify(oJSON),
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				success: function (response) {
					
					// Display the success bubble.
					g_oGreenlightMessages.displaySuccessBubble(g_oAnnotations.c_szAnnotationSavedSuccessfully);

					// If we are in text compare mode, stop here as we do not want to render this annotation.
					if (g_oTextCompare.g_bTextCompareInProgress) {
						return;
					}

					// Determine the canvas to used for rendering based on the annotation toggle.
					var oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
					var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

					// Splice the old ID out the array, it will be re-rendered later.
					if (g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.documentType === eDocumentTypes.ThreeD) {
						for (var i = (oArtworkCanvas.g_oScene.children.length - 1); i > -1; i--) {
							// Remove both the Annotation object & the Annotation Number from the 3D scene array.
							if (oArtworkCanvas.g_oScene.children[i].Id == _this.id || oArtworkCanvas.g_oScene.children[i].Id == "annNo_" + _this.id) {
								oArtworkCanvas.g_oScene.children.splice(i, 1);
							}
						}
					}

					// Gather the text annotations.
					g_oAnnotations.g_oExistingTextAnnotations = $.grep(g_oAnnotations.g_oAnnotationsMade, function (anno) {
						return anno.g_iAnnotationType === eAnnotationTypes.TextMeasurement;
					});

					// Reset the annotations, and re-load these from the new response content.
					g_oAnnotations.g_oAnnotationsMade = [];
					if (bNewThreeDViewAnnotation) {
						var responseObj = JSON.parse(response.Contents);
						g_oAnnotations.setupAnnotations(responseObj.Annotations, oArtworkCanvas, oAnnotationCanvas, responseObj.ColladaModelTexture);
					}
					else {
						g_oAnnotations.setupAnnotations(JSON.parse(response.Contents), oArtworkCanvas, oAnnotationCanvas);
					}
					
					// If this was a new copy magic annotation, create any required additional shapes.
					if (oNewCopyMagicTextAnnotation != null) {

						// Generate and save each of the additional shapes.
						var oAdditionalShapeAnnotations = g_oSVGCopyMagic.generateCopyMagicAdditionalShapes(oNewCopyMagicTextAnnotation.switchId, oNewCopyMagicTextAnnotation.contentDataId, oNewCopyMagicTextAnnotation.contentId, oArtworkCanvas, oAnnotationCanvas);
						for (var i = 0; i < oAdditionalShapeAnnotations.length; i++) {
							g_oAnnotations.g_oAnnotationsMade.push(oAdditionalShapeAnnotations[i]);
							oAdditionalShapeAnnotations[i].annotationSaveShape(oAnnotationCanvas, false);
						}
					}

					// If the annotation save was called on the main annotation only
					$(".annotation").remove();

					// Redraw the annotation canvas.
					oAnnotationCanvas.redraw(false);

					// Recalculate the page annotation numbers.
					g_oAnnotations.renderPageAnnotationNumbers();

					// Update the signal-r.
					try {
						g_oAnnotations.g_oAnnotationHub.server.send(g_oAnnotations.g_iApprovalId, g_oUserDetails.EmailAddress);
					}
					catch (ex) {
						// do nothing
					}

					// Rebind the draw functions once annotation saves.
					// Use setTimeout to make sure we ONLY rebind the canvas functions,
					// once they have finished, as they will execute twice!.
					var oTimer = setTimeout(function () {
						g_oAnnotations.currentTimeoutListRemove(oTimer);

						// Only reset the annotation mouse events if there are no other actions in progress (i.e. Pan or Marquee Zoom).
						if (!g_oAnnotations.g_bNonAnnotationActionInProgress) {
							// Rebind previous draw/measurement by faking a click on the last selected tool.
							$(g_oAnnotations.g_oLastUsedTool).click();
						}
					}, 1000);

					g_oAnnotations.currentTimeoutListAdd(oTimer);

					// Set the position of the list following the re-render.
					$("#divAnnDiv_ListItems").scrollTop(iListScrollTop);
				},
				failure: function () {
					g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szAnnotationFailedtoSave);
				},
				error: function () {
					g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szAnnotationFailedtoSave);
				}
			});
		}
	};

	/**
	 * Called when adding a new shape.
	 * @param {object} oAnnotationCanvas - The annotation canvas
	 * @param {bool} bUpdating - Whether it's an update event or not.
	 */
	Annotation.prototype.annotationSaveShape = function (oAnnotationCanvas, bUpdating) {
		var oThisAnnotation = this;
		bUpdating = (typeof(bUpdating) !== "undefined") ? bUpdating : false;

		// Create the array co-ordinates for the annotations.
		var annotationCoords = [];

		for (var i = 0; i < oThisAnnotation.g_oDrawArray.length; i++) {
			var oAnnotationCoordObject = {
				annotationId: oThisAnnotation.id,
				annotationX: oThisAnnotation.g_oDrawArray[i][0],
				annotationY: oThisAnnotation.g_oDrawArray[i][1],
				annotationZ: (typeof(oThisAnnotation.g_oDrawArray[i][2]) !== "undefined") ? oThisAnnotation.g_oDrawArray[i][i + 2] : null,
				marqueeX: null,
				marqueeY: null
			};

			annotationCoords.push(oAnnotationCoordObject);
		}

		if (g_oAnnotations.g_oPreviouslySavedAnnotationCoords == annotationCoords) {
			// We have a duplicate annotation! Return so we don't save it.
			return;
		}

		// Update the previous Annotation coordinates to the new set that we're about to save.
		g_oAnnotations.g_oPreviouslySavedAnnotationCoords = deepCopyArray(annotationCoords);

		// Create a cut down version of the Annotation object to be passed to the server.
		var oAnnotationObject = {
			annotationId: this.id,
			approvalId: this.g_iApprovalId,
			approvalUserId: this.g_iAuthor,
			documentId: this.g_iDocumentId,
			documentPageId: this.g_iDocumentPageId,
			replyToAnnotId: this.g_iParentAnnotationId,
			annotationType: this.g_iAnnotationType,
			annotationDateTime: "",
			modifiedDateTime: "",
			svgVariableId: JSON.stringify(this.g_oSVGVariable),
			svgOriginalContent: this.g_szSVGOriginalContent,
			annotationContent: this.g_szTextContent,
			annotationColour: g_oAnnotations.getHexColour(this.g_szColour) || this.g_szColour,
			unlocked: false,
			deleted: false,
			annotationReplies: [],
			annotationStatuses: [],
			annotationCoords: annotationCoords,
			attachments: this.attachments
		};

		// Set the variables to point at the right method and give the right messages if it's updating the shape or not.
		var szUrlString = bUpdating ? "internal/GreenlightAnnotation/UpdateAnnotationShape" : "internal/GreenlightAnnotation/SaveAnnotationShape";
		var szSuccessMessage = bUpdating ? g_oAnnotations.c_szAnnotationUpdateSuccess : g_oAnnotations.c_szAnnotationSavedSuccessfully;
		var szErrorMessage = bUpdating ? g_oAnnotations.c_szAnnotationUpdateFail : g_oAnnotations.c_szAnnotationFailedtoSave;
		var bSetCoords = !bUpdating;

		if (bUpdating) {
			var tmp = [];
			for (var i = 0; i < this.g_oDrawCoordSetArray.length; i++) {
				var oAnnotationCoordObject = {
					annotationCoordId: this.g_oDrawCoordSetArray[i].annotationCoordId,
					annotationId: this.g_oDrawCoordSetArray[i].annotationId,
					annotationX: this.g_oDrawCoordSetArray[i].xCoordinate,
					annotationY: this.g_oDrawCoordSetArray[i].yCoordinate,
					annotationZ: this.g_oDrawCoordSetArray[i].zCoordinate,
					marqueeX: null,
					marqueeY: null
				};
				tmp.push(oAnnotationCoordObject);
			}
			// Overwrite the previous coordinates which didn't have the coordinate id
			oAnnotationObject.annotationCoords = tmp;
		}

		// Build up the annotation string.
		var oJSON = {
			ApprovalId: this.g_iApprovalId,
			SessionId: g_oAnnotations.c_szSessionId,
			AnnotationShape: oAnnotationObject
		};
		$.ajax({
			type: "POST",
			url: szUrlString,
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oGreenlightMessages.displaySuccessBubble(szSuccessMessage);

				// Update the annotation just made.
				oThisAnnotation.updateSavedShape(response, oThisAnnotation.id, bSetCoords);
				oThisAnnotation.g_bSaved = true;

				// If the annotation save was called on the main annotation only
				$(".annotation").remove();
				try {
					g_oAnnotations.g_oAnnotationHub.server.send(g_oAnnotations.g_iApprovalId, g_oUserDetails.EmailAddress);
				}
				catch (ex){
					console.log(g_oAnnotations.c_szFailedToNotifyOthersMessage);
				}
				oAnnotationCanvas.redraw(false);

				if (bSetCoords) { // Saving new child
					$("#AnnotationViewer").on("pointermove.annotationUI", function (e) {
						g_oAnnotationActions.mouseMoveLite(e, g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId), oAnnotationCanvas);
					});
				}

			},
			failure: function () {
				g_oGreenlightMessages.displayErrorBubble(szErrorMessage);
			},
			error: function () {
				g_oGreenlightMessages.displayErrorBubble(szErrorMessage);
			}
		});
	};

	/**
	 * On Click for the annotation edit button.
	 * @param {event} e - The event object for the on click.
	 */
	function EditButtonOnClick(e) {

		// Stop the defult click behaviours.
		e.preventDefault();
		e.stopPropagation();

		// Ensure we are not already editing text classification data.
		if ($(".saveAnnotationDataButton").length > 0) {
			g_oGreenlightMessages.displayErrorBubble("Please save any outstanding changes to text classifications.");
			return;
		}

		// Note the scroll position of the list before the re-render.
		var iListScrollTop = $("#divAnnDiv_ListItems").scrollTop();

		// Work out whether or not this is read-only.
		var bReadOnly = false;
		if ($(this).parent().hasClass("ReadOnlyReplyText")) {
			bReadOnly = true;
		}

		// Grab the various elements of the edit button we just clicked on.
		var relatedAnnotationId;
		var relatedAnnotationDiv = $(this).parents(".speechbubble");
		var relatedAnnotationListItem = $(this).parents(".annotationListItem");

		// Get the artwork and annotation canvas based on the related annotation item.
		var oArtworkCanvas = null;
		var oAnnotationCanvas = null;

		// If we have clicked the edit button from an annotation div.
		if (relatedAnnotationDiv.length === 0) {
			relatedAnnotationId = parseInt(relatedAnnotationListItem[0].id.substring(3), 10);
			oArtworkCanvas = g_oViewer.getCanvas($("#" + relatedAnnotationListItem[0].id).attr("data-artworkCanvas"));
			oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;
		}
		// If we have clicked the edit button from an annotation list item.
		else {
			relatedAnnotationId = parseInt(relatedAnnotationDiv[0].id, 10);
			oArtworkCanvas = g_oViewer.getCanvas($("#" + relatedAnnotationDiv[0].id).attr("data-artworkCanvas"));
			oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;
		}

		// Find the annotation.
		var relatedAnnotation = $.grep(g_oAnnotations.g_oAnnotationsMade, function (ann) { return ann.id == relatedAnnotationId; });

		// If we could not find the annotation.
		if (!relatedAnnotation.length > 0) {

			// Find the annotation reply.
			relatedAnnotation = $.grep(g_oAnnotations.g_oReplies, function (ann) { return ann.id == relatedAnnotationId; });
		}

		// Remove the divs from the page as these will be rendered later.
		$(".annotationListItem").remove();
		$(".annotation").remove();

		// Create a list of annotations to be populated.
		var annotations = [];

		// Loop through each of the annotations.
		for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {

			// Skip if this annotation is an SVG hover or search.
			if (g_oAnnotations.g_oAnnotationsMade[i].g_bSVGHoverAnnotation || g_oAnnotations.g_oAnnotationsMade[i].g_bSVGSearchAnnotation) {
				continue;
			}

			// Ensure the annotation is on the current page.
			if ($.isEmptyObject(oArtworkCanvas.g_oDoc.pages)) {
				oArtworkCanvas.g_oDoc.documentId == g_oAnnotations.g_oAnnotationsMade[i].g_iDocumentId ? annotations.push(g_oAnnotations.g_oAnnotationsMade[i]) : "";
			}
			else {
				// Loop through the pages.
				for (var j = 0; j < oArtworkCanvas.g_oDoc.pages.length; j++) {
					if (oArtworkCanvas.g_oDoc.pages[j].documentPageId == g_oAnnotations.g_oAnnotationsMade[i].g_iDocumentPageId &&
						(oArtworkCanvas.g_iCurrentPage == oArtworkCanvas.g_oDoc.pages[j].documentPageNumber)) {
						annotations.push(g_oAnnotations.g_oAnnotationsMade[i]);
						break;
					}
				}
			}
		}

		// Sort the annotations by number so they get re-added to the list correctly.
		annotations.sort(function (a, b) {
			return a.g_iNumber - b.g_iNumber;
		});

		// Apply any annotation filters.
		annotations = g_oFilter.applyAnnotationFilters(annotations);

		// This loops through all the annotations on the current page.
		// This either, re-renders the editable text box or adds it to be rendered in the list.
		for (var l = 0; l < annotations.length; l++) {

			// If we have a match to the annotation that we're changing
			if (relatedAnnotation[0].id === annotations[l].id) {

				// And the change was initiated from a pop-up.
				if (relatedAnnotationDiv.length !== 0) {

					// Create both the pop-up AND list item Div (in read only mode).
					// Use the event object id to work out if this edit button clicked on was a reply, as the edit has the ID added as an extra attribute.
					relatedAnnotation[0].createAnnotationDiv(eAnnotationDivType.Popup, bReadOnly, e.currentTarget.id.substr(e.currentTarget.id.lastIndexOf("_") + 1), oArtworkCanvas, oAnnotationCanvas);
					relatedAnnotation[0].createAnnotationDiv(eAnnotationDivType.ListItem, true, null, oArtworkCanvas, oAnnotationCanvas);

					// If this is not a 3D canvas.
					if (g_oAnnotations.g_iApprovalType !== eDocumentTypes.ThreeD) {
						oAnnotationCanvas.redraw(false);
					}
					// If this is a 3D canvas.
					else {
						g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
						oArtworkCanvas.g_oRenderer.render(oArtworkCanvas.g_oScene, oArtworkCanvas.g_oCamera);
						AnnotationUI.prototype.repositionSpeechBubbles(oArtworkCanvas, oAnnotationCanvas);
					}

					changeCanvasFunction(".jqte_editor", "focus", function (e) {
						changeCanvasFunction("#AnnotationViewer", "pointerdown", function (e) {
							relatedAnnotation[0].AnnotationTextEditorLooseFocusEvent(e, relatedAnnotation[0], null, oArtworkCanvas, oAnnotationCanvas);
						});
					});

					$(".jqte_editor").focus();
					relatedAnnotation[0].g_bSaved = false;
				}
				else {
					// The change was initiated from a list item, but check anyway
					if (relatedAnnotationListItem.length !== 0) {
						if (relatedAnnotation[0].g_iParentAnnotationId === 0 || relatedAnnotation[0].g_iParentAnnotationId === "undefined") {
							relatedAnnotation[0].createAnnotationDiv(eAnnotationDivType.ListItem, bReadOnly, e.currentTarget.id.substr(e.currentTarget.id.lastIndexOf("_") + 1), oArtworkCanvas, oAnnotationCanvas);
						}

						if (g_oAnnotations.g_iApprovalType !== eDocumentTypes.ThreeD) {
							oAnnotationCanvas.redraw(false);
						}
						else {
							g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
							oArtworkCanvas.g_oRenderer.render(oArtworkCanvas.g_oScene, oArtworkCanvas.g_oCamera);
						}

						changeCanvasFunction(".jqte_editor", "focus", function (e) {
							changeCanvasFunction("#AnnotationViewer", "pointerdown", function (e) {
								relatedAnnotation[0].AnnotationTextEditorLooseFocusEvent(e, relatedAnnotation[0], null, oArtworkCanvas, oAnnotationCanvas);
							});
						});

						$(".jqte_editor").focus();
						relatedAnnotation[0].g_bSaved = false;
						if ($("#" + relatedAnnotationListItem[0].id).length && $("#" + relatedAnnotationListItem[0].id).attr("class").indexOf("annotationListItemSelected") === -1) {
							var oElement = document.getElementById(relatedAnnotationListItem[0].id);
							$("#" + oElement.id).click();
						}
					}
				}
			}
			else {
				// Not the annotation that we're changing. But we need to recreate the list item anyway.
				if (annotations[l].g_iParentAnnotationId == 0) {
					annotations[l].createAnnotationDiv(eAnnotationDivType.ListItem, true, null, oArtworkCanvas, oAnnotationCanvas);
				}
			}
		}

		// Set the position of the list following the re-render.
		$("#divAnnDiv_ListItems").scrollTop(iListScrollTop);

		// Scroll to the edited annotaton item in the list.
		Annotation.prototype.scrollEditAnnotation(relatedAnnotation[0]);
	}

	/**
	 * Pans to a select annotation
	 * @param {any} oArtworkCanvas - The artwork canvas.
	 * @param {any} oAnnotationCanvas - The annotation canvas.
	 */
	Annotation.prototype.panToAnnotation = function (oArtworkCanvas, oAnnotationCanvas, oSyncCanvas) {
		var parentCanvasObj = oAnnotationCanvas;
		var parentArtworkViewer = oArtworkCanvas;
		if (parentArtworkViewer.g_iZoomLevel != 1) {
			var annotationCoords = this.g_oDrawArray;
			var annotationBounds = [1, 1, 0, 0];
			var annotationMidPoint;
			for (var i = 0; i < annotationCoords.length; i++) {
				if (annotationCoords[i][0] < annotationBounds[0]) {
					annotationBounds[0] = annotationCoords[i][0];
				}

				if (annotationCoords[i][1] < annotationBounds[1]) {
					annotationBounds[1] = annotationCoords[i][1];
				}

				if (annotationCoords[i][0] > annotationBounds[2]) {
					annotationBounds[2] = annotationCoords[i][0];
				}

				if (annotationCoords[i][1] > annotationBounds[3]) {
					annotationBounds[3] = annotationCoords[i][1];
				}
			}

			var maxCanvasWidth = parentArtworkViewer.g_iScaledImageWidth;
			var maxCanvasHeight = parentArtworkViewer.g_iScaledImageHeight;

			for (var syncCanvas in oSyncCanvas) {
				if (oSyncCanvas[syncCanvas].g_iZoomLevel == parentArtworkViewer.g_iZoomLevel) {
					maxCanvasWidth = Math.max(maxCanvasWidth, oSyncCanvas[syncCanvas].g_iScaledImageWidth);
					maxCanvasHeight = Math.max(maxCanvasHeight, oSyncCanvas[syncCanvas].g_iScaledImageHeight);
				}
			}

			annotationMidPoint = [annotationBounds[0] + ((annotationBounds[2] - annotationBounds[0]) / 2), annotationBounds[1] + ((annotationBounds[3] - annotationBounds[1]) / 2)];
			parentArtworkViewer.g_iTempDragOffset_x = (annotationMidPoint[0] * parentArtworkViewer.g_iScaledImageWidth) - (maxCanvasWidth / 2);
			parentArtworkViewer.g_iTempDragOffset_y = (annotationMidPoint[1] * parentArtworkViewer.g_iScaledImageHeight) - (maxCanvasHeight / 2);
			parentArtworkViewer.g_iDragXDiff = (parentArtworkViewer.g_iDragOffset_x - parentArtworkViewer.g_iTempDragOffset_x) / parentCanvasObj.g_iAnimateFrames;
			parentArtworkViewer.g_iDragYDiff = (parentArtworkViewer.g_iDragOffset_y - parentArtworkViewer.g_iTempDragOffset_y) / parentCanvasObj.g_iAnimateFrames;

			for (var syncCanvas in oSyncCanvas) {
				oSyncCanvas[syncCanvas].synchroniseZoomPanProperties(parentArtworkViewer);
				oSyncCanvas[syncCanvas].g_oCanvasZoom.startZoomAnimate();
			}

			parentArtworkViewer.g_oCanvasZoom.startZoomAnimate();
		}
	};

	/**
	 * Updates a newly created annotation with the ID and sets the coordinate set object.
	 * @param {object} oReturnedAnnotation - The server response as a JSON string.
	 * @param {int} iTempId - The temporary ID given to this annotation.
	 * @param {bool} bSetCoords - Boolean whether to set the annotation coordinates set object
	 */
	Annotation.prototype.updateSavedShape = function (oReturnedAnnotation, iTempId, bSetCoords) {
		// Find the annotation and update.
		for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {
			if (g_oAnnotations.g_oAnnotationsMade[i].id === iTempId) {
				g_oAnnotations.g_oAnnotationsMade[i].id = oReturnedAnnotation.annotationId;
				if (bSetCoords) {
					for (var j = 0; j < oReturnedAnnotation.annotationCoords.length; j++) {
						var coordSet = g_oAnnotations.DrawCoordinatesSet(oReturnedAnnotation.annotationCoords[j].annotationId,
							oReturnedAnnotation.annotationId,
							oReturnedAnnotation.annotationCoords[j].annotationX,
							oReturnedAnnotation.annotationCoords[j].annotationY,
							oReturnedAnnotation.annotationCoords[j].annotationZ != null ? oReturnedAnnotation.annotationCoords[j].annotationZ : "");
						g_oAnnotations.g_oAnnotationsMade[i].g_oDrawCoordSetArray.push(coordSet);
					}
				}
				break;
			}
		}
	};

	/**
	 * Updates a newly created Annotation with it's ID from the database.
	 * @param {string} response - The server response as a JSON String.
	 * @param {number} tempId - The temporary ID given to this annotation
	 */
	Annotation.prototype.updateAnnotationId = function (response, tempId) {
		var oReturnedAnnotation = JSON.parse(response);
		// Find the annotation and update.
		for (var i = 0; i < g_oAnnotations.g_oAnnotationsMade.length; i++) {
			if (g_oAnnotations.g_oAnnotationsMade[i].id === tempId) {
				g_oAnnotations.g_oAnnotationsMade[i].id = oReturnedAnnotation.annotationId;
				break;
			}
		}
	};

	/**
	 * Highlights the text measurement.
	 * @param {any} bApplyTextHighlight - Boolean whether to apply the text highlight.
	 * @param {any} oArtworkCanvas - The artwork canvas.
	 * @param {any} oAnnotationCanvas - The annotation canvas.
	 */
	Annotation.prototype.highlightTextMeasurementWords = function (bApplyTextHighlight, oArtworkCanvas, oAnnotationCanvas) {
		
		// If the annotation type is a text measurement.
		if (this.g_iAnnotationType === eAnnotationTypes.TextMeasurement) {

			// Get the canvas scaled image width and height.
			var iScaledImageWidth = oArtworkCanvas.g_iScaledImageWidth;
			var iScaledImageHeight = oArtworkCanvas.g_iScaledImageHeight;

			// Calculate the compare offset on the artwork canvas.
			var compareOffset_x, compareOffset_y;
			var co = g_oCompare.calculateCompareOffsetInPx(oArtworkCanvas);
			compareOffset_x = co.x;
			compareOffset_y = co.y;

			// Get the compare rotation of the canvas.
			var iCompareRotation = g_oCompare.getCompareRotation(oArtworkCanvas);

			// If we have a compare rotation of 90 or 270, swap the scaled image width and height.
			if (iCompareRotation == 90 || iCompareRotation == 270) {
				iScaledImageWidth = oArtworkCanvas.g_iScaledImageHeight;
				iScaledImageHeight = oArtworkCanvas.g_iScaledImageWidth;
			}

			// If the text measurement words array is populated.
			if (this.g_oTextMeasurementWordsArray !== undefined && this.g_oTextMeasurementWordsArray.length !== 0) {

				// Loop through each of the text measurement words.
				for (var m = 0; m < this.g_oTextMeasurementWordsArray.length; m++) {

					// Get the text measurement word.
					var word = this.g_oTextMeasurementWordsArray[m].ChildTextElements;

					// For each of the letters in the word.
					for (var n = 0; n < word.length; n++) {

						// Get the positions of the letter.
						var iLowerLeftX = word[n].Llx;
						var iLowerLeftY = word[n].Lly;
						var iUpperRightX = word[n].Urx;
						var iUpperRightY = word[n].Ury;

						// If we have a compare rotation.
						if (iCompareRotation > 0) {

							// Rotate the lower left positions.
							var oRotatedLetterLower = oAnnotationCanvas.rotate(iLowerLeftX, iLowerLeftY, 0.5, 0.5, iCompareRotation);
							iLowerLeftX = oRotatedLetterLower.rotated_x;
							iLowerLeftY = oRotatedLetterLower.rotated_y;

							// Rotate the upper right positions.
							var oRotatedLetterUpper = oAnnotationCanvas.rotate(iUpperRightX, iUpperRightY, 0.5, 0.5, iCompareRotation);
							iUpperRightX = oRotatedLetterUpper.rotated_x;
							iUpperRightY = oRotatedLetterUpper.rotated_y;
						}

						// Calculate the start positions and distance.
						var startX = (iLowerLeftX * iScaledImageWidth) + oArtworkCanvas.g_iCenterShift_x + compareOffset_x;
						var startY = (iUpperRightY * iScaledImageHeight) + oArtworkCanvas.g_iCenterShift_y + compareOffset_y;
						var distX = ((iUpperRightX - iLowerLeftX) * iScaledImageWidth);
						var distY = ((iLowerLeftY - iUpperRightY) * iScaledImageHeight);

						oAnnotationCanvas.removeTextHighlight(oAnnotationCanvas.g_oContext, startX, startY, distX, distY);

						if (word[n].IsTextVisible && bApplyTextHighlight) {
							oAnnotationCanvas.drawTextHighlight(oAnnotationCanvas.g_oContext, startX, startY, distX, distY, g_oAnnotations.g_szTextMeasurementFill);
						}

						if (word[n].insertedCharsBefore) {
							if (word[n].insertedCharsBefore.length) {
								var insStartX = (iLowerLeftX * iScaledImageWidth) + oArtworkCanvas.g_iCenterShift_x + compareOffset_x - (distX / 2);
								var insStartY = (iUpperRightY * iScaledImageHeight) + oArtworkCanvas.g_iCenterShift_y + compareOffset_y - (distY / 2);
								var insDistX = distX;
								var insDistY = distY;

								oAnnotationCanvas.removeTextHighlight(oAnnotationCanvas.g_oContext, insStartX, insStartY, insDistX, insDistY);

								if (word[n].IsTextVisible && bApplyTextHighlight) {
									oAnnotationCanvas.drawTextHighlight(oAnnotationCanvas.g_oContext, insStartX, insStartY, insDistX, insDistY, g_oAnnotations.g_szTextMeasurementFill);
								}
							}
						}

						// Draw highlight in the middle of any inserted chars and offset by 50% vertically
						if (word[n].insertedCharsAfter) {
							if (word[n].insertedCharsAfter.length) {
								var insStartX = (iLowerLeftX * iScaledImageWidth) + oArtworkCanvas.g_iCenterShift_x + compareOffset_x - (distX / 2);
								var insStartY = (iUpperRightY * iScaledImageHeight) + oArtworkCanvas.g_iCenterShift_y + compareOffset_y - (distY / 2);
								var insDistX = distX;
								var insDistY = distY;

								oAnnotationCanvas.removeTextHighlight(oAnnotationCanvas.g_oContext, insStartX, insStartY, insDistX, insDistY);

								if (word[n].IsTextVisible && bApplyTextHighlight) {
									oAnnotationCanvas.drawTextHighlight(oAnnotationCanvas.g_oContext, insStartX, insStartY, insDistX, insDistY, g_oAnnotations.g_szTextMeasurementFill);
								}
							}
						}
					}
				}
			}
		}
	};

	// These functions convert a 2D annotation point - uvx, uvy - into 3D.

	// Pass in the annotation 2d point (mid or start etc) that you want to convert.
	// Get back the 3d coordinates IF the annotation point exists against the relevant 3D texture.
	/**
	 *
	 * @param {any} uvx
	 * @param {any} uvy
	 * @param {any} szColladaModelTexture
	 * @param {any} oScene
	 */
	Annotation.prototype.Convert2DTo3DAnnotation = function (uvx, uvy, szColladaModelTexture, oScene) {
		// Reverse the y coordinate. PDF Y coordinates measured from bottom up.
		uvy = 1 - uvy;
				// First we traverse the polygons in the model to determine if there is anything that has a geometry.
		// The three.js scene object describes all objects in the 3d world.
		var annotation3DPoint = g_oThreeDView.TraversePolygonsForGeometries(oScene, uvx, uvy, this.g_iDocumentId, szColladaModelTexture);

        // Clear draw array
        this.g_oDrawArray = [];
        // Change type to 3D annotation
        this.g_iAnnotationType = eAnnotationTypes.ThreeD;
        if (annotation3DPoint) {
			this.g_oDrawArray.push([annotation3DPoint.x, annotation3DPoint.y, annotation3DPoint.z]);
        } else {
            // Annotation is out of artwork bounds
            // Stick it in the middle
            this.g_oDrawArray.push([0, 0, 0]);
        }
    };

	/**
	* Manage the entire colour selection and changing of the annotation 
    * @param {object} oAnnotationCanvas - Annotation canvas area.
    **/
	Annotation.prototype.SelectColourFromDisplay = function (oAnnotationCanvas) {
		var annotationStack = g_oAnnotations.filteredAnnotationStack(g_oAnnotations.g_oAnnotationsMade);
		// Delete the div to clear the dotted line to annotation div if present
		$(this).parent().remove();
		event.stopPropagation();
		
		$(".annotationviewer").off("pointerdown");
		$(".annotationviewer").off("pointerup");
		
		oAnnotationCanvas.redraw(false);
		var result = $.grep(annotationStack, function (annotation) { return annotation.id === g_oAnnotations.g_AnnotationId; });
		
		if (result.length || result.length > 0) {
			// Popup colour selection grid.
			Annotation.prototype.DisplayColourSelection(result[0].g_szColour, event);
		}
		else {
			g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szColourErrorUnableToFind);
		}
	};

	/**
	 * Remove the NoAfter if we are dealing with speech bubbles
	 */ 
	Annotation.prototype.ResetPreviousSelection = function () {
		if (g_oAnnotations.g_oPreviousSpeechAnnotation && g_oAnnotations.g_oPreviousSpeechAnnotationArrow) {
			g_oAnnotations.g_oPreviousSpeechAnnotation.classList.remove("noAfter");

			g_oAnnotations.g_oPreviousSpeechAnnotationArrow = false;
			g_oAnnotations.g_oPreviousSpeechAnnotation = null;
		}
	};

	/**
	 * popup a colour selection panel.
	 * @param {string} szPreviousColour - Previous colour.
	 * @param {obj} event - The event.
	 */
	Annotation.prototype.DisplayColourSelection = function (szPreviousColour, event) {
		
		// Update the annotation colour.
		g_oSettings.g_oUserSettings.AnnotationColour = g_oAnnotations.getHexColour(szPreviousColour);
		g_oSettings.updateSettingAnnotationColour(true);

		// Preset the user tools.
		AnnotationUI.prototype.presetUserTools();

		// clone the colour thingie.
		var oActive = null;

		// if we are a list annotation
		var bListAnnotation = false;

		// name of the colour selection icon we need to attach too.
		var szSelectedAnnotationColourIcon = "";

		var id = (event.toElement == undefined) ? event.target.id : event.toElement.id;
		var bIsAddShapeAvailable = undefined;

		// check if our previous item is a speech bubble as we need to remove the noAfter to show our box pointer.
		Annotation.prototype.ResetPreviousSelection();

		if ("scPop_" + g_oAnnotations.g_AnnotationId.toString() === id) {
			oActive = document.getElementById(g_oAnnotations.g_AnnotationId.toString());
			g_oAnnotations.g_oPreviousSpeechAnnotation = oActive;
			szSelectedAnnotationColourIcon = "sc_" + g_oAnnotations.g_AnnotationId.toString();
			bIsAddShapeAvailable = document.getElementById("asb_" + g_oAnnotations.g_AnnotationId.toString())
		}
		else { 
			oActive = document.getElementById("li_" + g_oAnnotations.g_AnnotationId.toString());
			bListAnnotation = true;
			szSelectedAnnotationColourIcon = "sc_li_" + g_oAnnotations.g_AnnotationId.toString();
			bIsAddShapeAvailable = document.getElementById("asb_li_" + g_oAnnotations.g_AnnotationId.toString())
		}

		// Check if we have a colour pop-up as we need to remove it.
		Annotation.prototype.RemoveLastColourSelection();

		if (oActive) {
			Annotation.prototype.ClearColourSelection((g_AvailableColours.indexOf(szPreviousColour) !== -1)
				? g_oAnnotations.getHexColour(szPreviousColour) : szPreviousColour);

			var szBackgroundColour = (g_oSettings.c_iSkinType == 0) ? "black" : "white";

			// get the original table to clone from.
			var colourGrid = document.getElementById("colourSelectionGridTable").cloneNode(true);
			if (colourGrid) {
				colourGrid.id = "newPopupColourSelection_1";
				colourGrid.style.background = szBackgroundColour;
				colourGrid.style.display = "block";

				// check if the shape icon is available, otherwise we need to move the colour selection.
				if (bIsAddShapeAvailable) {
					colourGrid.style['margin-top'] = "28px";
					colourGrid.style['margin-left'] = "21px";
				}
				else {
					colourGrid.style['margin-top'] = "28px";
					colourGrid.style['margin-left'] = "4px";
				}
				
				// get the colour selection icon as we need to attach our selection to this.
				var oSectionToAppendTo = document.getElementById(szSelectedAnnotationColourIcon);
				if (oSectionToAppendTo) {
					oSectionToAppendTo.appendChild(colourGrid);
				}

				// we need to add and the new class and toggle when we are type 1 interface
				if (g_oSettings.c_iSkinType == 1) {
					document.getElementById("newPopupColourSelection_1").classList.add("dvPopupAnnotationWhiteColour");
					document.getElementById("newPopupColourSelection_1").classList.add("colorWhiteSelection");
				}
				
				// check if we have a noAfter as this draws the speech bubble arrow.
				if (!oActive.classList.contains("noAfter")) {
					$(oActive).addClass("noAfter");
					g_oAnnotations.g_oPreviousSpeechAnnotationArrow = true;
				}
				
				// handle the resizing.
				Annotation.prototype.ResizeColourSelection(false);
				
				// Scroll the colour selection tool into view.
				Annotation.prototype.scrollColourSelection(oActive, colourGrid, bListAnnotation);
			} 
		}
	};

	/**
	 * Clears the popup colour selection grid of the last selection.
	 * @param {string} szColour  - Remove any highlighted from colour selection.
	 **/
	Annotation.prototype.ClearColourSelection = function (szColour) {
		for (var i = 0; i < g_AvailableColours.length; i++) {
			var oColourElement = $("#annotatePopUpTable" + g_AvailableColours[i].charAt(0).toUpperCase() + g_AvailableColours[i].substring(1))
			$(oColourElement).css("background", g_AvailableColours[i]);

			if (g_oAnnotations.getHexColour(g_AvailableColours[i]) != szColour) {
				$(oColourElement).css("border-color", g_AvailableColours[i]);

				// change the main selection colour to this colour.
				var oColourElement = document.getElementById("annotate" + g_AvailableColours[i].charAt(0).toUpperCase() + g_AvailableColours[i].substring(1));
				$(oColourElement).css("border-color", g_AvailableColours[i]);
			}
		}
	};

	/**
	 * Remove the colour element from the class.
	 * @param {object} oElement - Speechbubble object to remove class from.
	 **/
	Annotation.prototype.RemoveColourClass = function (oElement) {
		for (var i = 0; i < g_AvailableColours.length; i++) {
			// check for camel case
			$(oElement).removeClass("annotation" + g_AvailableColours[i].charAt(0).toUpperCase() + g_AvailableColours[i].substring(1))
			// check for lower case
			$(oElement).removeClass("annotation" + g_AvailableColours[i].toLowerCase());
		}
	}

	/**
	 * A coulour has been selected now we need to update the various annotations.
	 **/
	Annotation.prototype.SelectedColour = function () {
		event.stopPropagation();
		event.preventDefault();
		
		// Get the local colour attribute.
		var szLocalColour = event.target.getAttribute('data-annotationcolour');

		// If found.
		if (szLocalColour !== undefined) {

			// If we are updating a colour setting.
			if ($(event.target).parents("#settingAnnotationColourPopup").length > 0) {

				// Update the annotation colour setting.
				g_oAnnotations.annotationColourChange(szLocalColour);
			}
			// Otherwise we are updating an annotation colour.
			else {

				var annotationStack = g_oAnnotations.filteredAnnotationStack(g_oAnnotations.g_oAnnotationsMade);
				var resultSelected = $.grep(annotationStack, function (annotation) { return annotation.id == g_oAnnotations.g_AnnotationId; });
				if (resultSelected.length > 0) {
					for (var i = 0; i < annotationStack.length; i++) {
						if (annotationStack[i].g_iNumber == resultSelected[0].g_iNumber) {

							// Get the previous colour.
							var szPreviousColour = annotationStack[i].g_szColour;

							// Update the colour to the newly selected colour.
							annotationStack[i].g_szColour = szLocalColour;

							// Set the new selected colour on the user tool menu.
							var oColourElement = document.getElementById("annotate" + szLocalColour.charAt(0).toUpperCase() + szLocalColour.substring(1));
							$(oColourElement).click();

							// Get the artwork and annotation canvas.
							var oArtworkCanvas = g_oViewer.getCanvas("ArtworkViewer");
							var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;

							// Delete the div to clear the dotted line to annotation div if present
							$(this).parent().remove();

							// Rebuild the annotation div.
							g_oAnnotations.rebuildAnnotationList(oArtworkCanvas, oAnnotationCanvas);
						}
					}

					// handle speech bubble colour changes.
					this.g_szColour = szLocalColour;
					var oSpeechBubble = document.getElementById(g_oAnnotations.g_AnnotationId.toString());
					if (oSpeechBubble) {
						this.RemoveColourClass(oSpeechBubble);
						$(oSpeechBubble).addClass("annotation" + szLocalColour);
					}

					// Get the save colour as a hex string.
					var szSaveNewColour = g_oAnnotations.getHexColour(szLocalColour);

					// Check if we have an annotation id and if not don't do any selection.
					if ((g_oAnnotations.g_AnnotationId !== -1) && (g_oAnnotations.g_AnnotationId !== undefined)) {

						// Convert the previous colour to a hex string.
						var szSavePrev = g_oAnnotations.getHexColour(szPreviousColour);
						
						// If we have changed colour.
						if (resultSelected.length > 0 && szSavePrev !== szSaveNewColour) {

							// Counter used to track the number.
							var iCallCount = 0;
							for (var i = 0; i < annotationStack.length; i++) {
								if (annotationStack[i].g_iNumber == resultSelected[0].g_iNumber) {

									// Call the save mechanism.
									Annotation.prototype.UpdateColourSelection(annotationStack[i].id, szSaveNewColour, g_oAnnotations.c_szColourUpdate.replace("{colour1}", g_oAnnotations.getStringColour(szPreviousColour)).replace("{colour2}", g_oAnnotations.getStringColour(szLocalColour)), g_oUserDetails.UserId, iCallCount);
									iCallCount += 1;
								}
							}
						}
					}

					// Check if we have a colour pop-up as we need to remove it.
					Annotation.prototype.RemoveLastColourSelection();

					// Override the pointer up event.
					if (oArtworkCanvas.g_oDoc.documentType === eDocumentTypes.ThreeD) {
						// remove the old number so we can call the re-create mechanism.
						for (var i = (oArtworkCanvas.g_oScene.children.length - 1); i > -1; i--) {
							// Remove both the Annotation object & the Annotation Number from the 3D scene array.
							if (oArtworkCanvas.g_oScene.children[i].Id == resultSelected[0].id ||
								oArtworkCanvas.g_oScene.children[i].Id == "annNo_" + resultSelected[0].id) {
								oArtworkCanvas.g_oScene.children.splice(i, 1);
							}
						}

						g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
						oArtworkCanvas.g_oRenderer.render(oArtworkCanvas.g_oScene, oArtworkCanvas.g_oCamera);
					}
					else {
						oArtworkCanvas.redraw(false);
					}

					// clear any selections
					g_oAnnotations.g_AnnotationId = null;
					g_oAnnotations.g_oAnnotationColSelected = szSaveNewColour;
				}
			}
		}
	};

	/**
	 * Perform the update of the annotation colour.
	 * @param {int} iId - ID of the annotation we want to update.
	 * @param {string} szHexColour - the colour we wisht to update too.
	 * @param {string} szAnnotationContent - Description of change.
	 * @param {int} iapprovalUserId - Who approved it.
	 * @param {int} iCallCount - The position of the save requests only occurs with multiple shapes
	 */
	Annotation.prototype.UpdateColourSelection = function (iId, szHexColour, szAnnotationContent, iapprovalUserId, iCallCount) {

		// Build up the annotation string.
		var oJSON = {
			iAnnotationId: iId,
			szAnnotationColour: szHexColour,
			annotationContent: szAnnotationContent,
			approvalUserId: iapprovalUserId
		};

		$.ajax({
			type: "POST",
			url: "internal/GreenlightAnnotation/UpdateColourAnnotation",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function () {
				if (iCallCount == 0) {
					// display success message.
					g_oGreenlightMessages.displaySuccessBubble(g_oAnnotations.c_szColourSuccessAnnotationText);
				}
			},
			failure: function () {
				if (iCallCount == 0) {
					// display failure message.
					g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szColourErrorAnnotationText);
				}
			}
		});
	}

	/**
	 * Handle the resize of the browser 
	 * @param {bool} bClearSelection - Option to clear colour selection pop-up.
	 **/
	Annotation.prototype.ResizeColourSelection = function (bClearSelection) {
		var colourGrid = document.getElementById("newPopupColourSelection_1");

		// remove colour pop-up only if we are resizing the canvas
		if (bClearSelection && (colourGrid != null || colourGrid != undefined)) {
			colourGrid.parentElement.removeChild(colourGrid);
			return;
		}
	};

	/*
	 * Catch the click event of the form and clean-up.
	 **/
	$(document).on('click', function (event) {
		Annotation.prototype.RemoveLastColourSelection();
	});

	/*
	 * Removes the last colour pop-up if it exists.
	 **/	
	Annotation.prototype.RemoveLastColourSelection = function () {
		var oNewPopupColour = document.getElementById("newPopupColourSelection_1");
		if (oNewPopupColour) {
			oNewPopupColour.parentElement.removeChild(oNewPopupColour);
		}
	};

	/**
	 * Scrolls to the colour selection tool once shown.
	 * @param {object} oAnnotationItem - The annotation item.
	 * @param {object} oColourGrid - The colour grid item.
	 * @param {bool} bListAnnotation - If the item is in a list or popup.
	 */
	Annotation.prototype.scrollColourSelection = function (oAnnotationItem, oColourGrid, bListAnnotation) {
		
		// If this is a list item, scroll the list.
		if (bListAnnotation) {
			Annotation.prototype.scrollColourSelectionList(oColourGrid);
		}
		// If this is a popup item, move the popup.
		else {
			Annotation.prototype.scrollColourSelectionPopup(oColourGrid, oAnnotationItem);
		}
	};

	/**
	 * Scroll to the colour selection tool in the list.
	 * @param {object} oColourGrid - The colour selection tool.
	 */
	Annotation.prototype.scrollColourSelectionList = function (oColourGrid) {

		// Get the position of the tool.
		var iToolPosition = $(oColourGrid).position().top;

		// Add the height of the tool.
		iToolPosition += $(oColourGrid).height();

		// Add the top margin of the tool.
		iToolPosition += parseInt($(oColourGrid).css("margin-top"));

		// If this is off the bottom of the div.
		if (iToolPosition > $("#divAnnDiv_ListItems").height()) {

			// Calculate the amount we need to scroll by, plus some nice padding.
			var iScrollAmount = iToolPosition - $("#divAnnDiv_ListItems").height() + 10;

			// Scroll the annotation list item into view.
			$("#divAnnDiv_ListItems").animate({ scrollTop: "+=" + iScrollAmount + "px" });
		}
	};

	/**
	 * Scroll to the colour selection tool in the popup.
	 * @param {object} oColourGrid - The colour selection tool.
	 * @param {object} oAnnotationItem - The annotation item.
	 */
	Annotation.prototype.scrollColourSelectionPopup = function (oColourGrid, oAnnotationItem) {

		// Determine the bottom position of the tooltip.
		var iToolBottomPosition = $(oAnnotationItem).position().top + $(oAnnotationItem).height() + $(oColourGrid).height() + 20;

		// If our tool has not overflown the height of the canvas holder.
		if (iToolBottomPosition < $("#divCanvasHolder").height()) {

			// We do not need to scroll the popup.
			return;
		}

		// Determine the overflow amount.
		var iOverflowAmount = iToolBottomPosition - $("#divCanvasHolder").height();

		// Add margin of 10px.
		iOverflowAmount += 10;

		// Move the bubble up by the height of the tool.
		$(oAnnotationItem).css("top", (parseInt($(oAnnotationItem).css("top").replace("px", "")) - iOverflowAmount) + "px");

		// Reposition the speech bubbles.
		Annotation.prototype.scrollRepositionSpeechBubbles(oAnnotationItem);
	};

	/**
	 * Scrolls to the annotation edit.
	 * @param {object} oAnnotationItem - The annotation that is being edited.
	 */
	Annotation.prototype.scrollEditAnnotation = function (oAnnotationItem) {
		
		// Get the position of the top and bottom of the annotation edit.
		var iEditStart = $("#li_" + oAnnotationItem.id).position().top;
		var iEditEnd = $("#li_" + oAnnotationItem.id).position().top + $("#li_" + oAnnotationItem.id).height();

		// If this is off the bottom of the div.
		if (iEditEnd > $("#divAnnDiv_ListItems").height()) {

			// Calculate the amount we need to scroll by plus some padding
			var iScrollDownAmount = iEditEnd - $("#divAnnDiv_ListItems").height() + 50;

			// Scroll the annotation edit into view.
			$("#divAnnDiv_ListItems").animate({ scrollTop: "+=" + iScrollDownAmount + "px" });
		}
		// If this is before the start of the div.
		else if (iEditStart < 0) {

			// Calculate the amount we need to scroll up by plus some padding.
			var iScrollUpAmount = iEditStart - 10;

			// Scroll the annotation edit into view.
			$("#divAnnDiv_ListItems").animate({ scrollTop: "+=" + iScrollUpAmount + "px" });
		}
	};

	/**
	 * Scrolls to the annotation reply.
	 * @param {object} oAnnotationItem - The annotation item.
	 * @param {object} bListItem - If the item is a list or popup.
	 */
	Annotation.prototype.scrollReplyAnnotation = function (oAnnotationItem, bListItem) {

		// If this is a list item.
		if (bListItem) {

			// Scroll the list.
			Annotation.prototype.scrollReplyAnnotationList(oAnnotationItem);
		}
		// If this is a popup.
		else {

			// Scroll the popup.
			Annotation.prototype.scrollRepositionSpeechBubbles(oAnnotationItem);
		}
		
		// Scroll the popup content to the bottom to ensure we can see the full reply.
		$(oAnnotationItem).children(".popup-content").scrollTop($(oAnnotationItem).children(".popup-content")[0].scrollHeight);
	};

	/**
	 * Scrolls the reply into view in the list.
	 * @param {object} oAnnotationItem - The annotation item.
	 */
	Annotation.prototype.scrollReplyAnnotationList = function (oAnnotationItem) {

		// Get the position of the footer underneath the reply.
		var iReplyPosition = $("#sc_" + oAnnotationItem.id).position().top;

		// If this is off the bottom of the div.
		if (iReplyPosition > $("#divAnnDiv_ListItems").height()) {

			// Calculate the amount we need to scroll by.
			var iScrollAmount = iReplyPosition - $("#divAnnDiv_ListItems").height();

			// Scroll the annotation list item into view.
			$("#divAnnDiv_ListItems").animate({ scrollTop: "+=" + iScrollAmount + "px" });
		}
	};

	/**
	 * Checks to see if a reply popup needs an initial scroll.
	 * @param {object} oAnnotationItem - The annotation to be checked.
	 * @returns {bool} - If the scroll is required.
	 */
	Annotation.prototype.preReplyScrollRequired = function (oAnnotationItem) {

		// Outline the variable to be returned..
		var bScrollRequired = false;

		// Determine the bottom position of the popup.
		var iPopupBottomPosition = $(oAnnotationItem).position().top + $(oAnnotationItem).height() + 100;

		// If our popup will overflow the canvas.
		if (iPopupBottomPosition > $("#divCanvasHolder").height()) {

			// We need to scroll the popup.
			bScrollRequired = true;
		}

		// Return if the scroll is required.
		return bScrollRequired;
	}

	/**
	 * Scrolls to the annotation status in the list if required.
	 * @param {object} oAnnotationItem - The annotation to scroll to the status of.
	 */
	Annotation.prototype.ScrollStatusAnnotationList = function (oAnnotationItem) {
		
		// Get the position of the top and bottom of the annotation status section.
		var iStatusStart = $("#sc_li_" + oAnnotationItem.id).position().top;
		var iStatusEnd = $("#li_" + oAnnotationItem.id).position().top + $("#li_" + oAnnotationItem.id).height();

		// If this is off the bottom of the div.
		if (iStatusEnd > $("#divAnnDiv_ListItems").height()) {

			// Calculate the amount we need to scroll by plus some padding
			var iScrollDownAmount = iStatusEnd - $("#divAnnDiv_ListItems").height() + 20;

			// Scroll the annotation status into view.
			$("#divAnnDiv_ListItems").animate({ scrollTop: "+=" + iScrollDownAmount + "px" });
		}
		// If this is before the start of the div.
		else if (iStatusStart < 0) {

			// Calculate the amount we need to scroll up by plus some padding.
			var iScrollUpAmount = iStatusStart - 150;

			// Scroll the annotation status into view.
			$("#divAnnDiv_ListItems").animate({ scrollTop: "+=" + iScrollUpAmount + "px" });
		}
	}

	/**
	 * Repositions the bubbles following auto scrolling.
	 * @param {object} oAnnotationItem - The annotation item.
	 */
	Annotation.prototype.scrollRepositionSpeechBubbles = function (oAnnotationItem) {

		// Reposition the speech bubbles.
		var oArtworkCanvas = g_oViewer.getCanvas(oAnnotationItem.getAttribute("data-artworkcanvas"));
		var oAnnotationCanvas = oArtworkCanvas.g_oAnnotationCanvas;
		oAnnotationCanvas.g_oContext.clearRect(0, 0, oAnnotationCanvas.g_oCanvas.width, oAnnotationCanvas.g_oCanvas.height);
		if (oArtworkCanvas.g_oDoc.documentType != eDocumentTypes.ThreeD) {
			g_oAnnotations.redrawAnnotations(oArtworkCanvas, oAnnotationCanvas);
		}
		else {
			g_oAnnotations.redraw3DAnnotations(oArtworkCanvas, oAnnotationCanvas);
		}
		AnnotationUI.prototype.repositionSpeechBubbles(oArtworkCanvas, oAnnotationCanvas);
	};

	// Add the Annotation UI object to the window.
	window.Annotation = Annotation;
}());